// // // import React, { useEffect, useState } from 'react';

// // // const CertificateList = ({ onSelect }) => {
// // //   const [certificates, setCertificates] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState('');

// // //   useEffect(() => {
// // //     const load = async () => {
// // //       try {
// // //         const res = await fetch('/api/certificates');
// // //         if (!res.ok) throw new Error('Failed to load certificates');
// // //         const data = await res.json();
// // //         setCertificates(data);
// // //       } catch (err) {
// // //         setError(err.message || 'Something went wrong.');
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };
// // //     load();
// // //   }, []);

// // //   if (loading) return <div className="card ctm-border-radius shadow-sm"><div className="card-body">Loading...</div></div>;
// // //   if (error) return <div className="alert alert-danger">{error}</div>;

// // //   return (
// // //     <div className="card ctm-border-radius shadow-sm grow">
// // //       <div className="card-body">
// // //         <h4 className="text-dark mb-4">All Certificates</h4>

// // //         {certificates.length === 0 ? (
// // //           <p className="text-muted">No certificates generated yet.</p>
// // //         ) : (
// // //           <table className="table table-hover">
// // //             <thead>
// // //               <tr>
// // //                 <th>Cert No.</th>
// // //                 <th>Student Name</th>
// // //                 <th>Branch</th>
// // //                 <th>Course</th>
// // //                 <th>Awarded On</th>
// // //                 <th></th>
// // //               </tr>
// // //             </thead>
// // //             <tbody>
// // //               {certificates.map((cert) => (
// // //                 <tr key={cert.certId}>
// // //                   <td>{cert.certNo}</td>
// // //                   <td>{cert.studentName}</td>
// // //                   <td>{cert.branch}</td>
// // //                   <td>{cert.course}</td>
// // //                   <td>{cert.awardedOn}</td>
// // //                   <td>
// // //                     <button className="btn btn-sm btn-primary" onClick={() => onSelect(cert)}>
// // //                       View
// // //                     </button>
// // //                   </td>
// // //                 </tr>
// // //               ))}
// // //             </tbody>
// // //           </table>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default CertificateList;




























// // /////sagar
// // import React, { useEffect, useState } from "react";

// // const CertificateList = ({ onSelect }) => {
// //   const [certificates, setCertificates] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");

// //   useEffect(() => {
// //     const load = async () => {
// //       try {
// //         const res = await fetch("/api/certificates");
// //         if (!res.ok) throw new Error("Failed to load certificates");
// //         const data = await res.json();
// //         setCertificates(data);
// //       } catch (err) {
// //         setError(err.message || "Something went wrong.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     load();
// //   }, []);

// //   if (loading)
// //     return (
// //       <div className="card ctm-border-radius shadow-sm">
// //         <div className="card-body">Loading...</div>
// //       </div>
// //     );
// //   if (error) return <div className="alert alert-danger">{error}</div>;

// //   return (
// //     <div className="w-full px-4 py-6">
// //       <div className="bg-white rounded-lg shadow-md overflow-hidden">
// //         <div className="p-4 md:p-6">
// //           <h4 className="text-gray-800 text-xl font-semibold mb-4 md:mb-6">
// //             All Certificates
// //           </h4>

// //           {certificates.length === 0 ? (
// //             <p className="text-gray-500 text-center py-8">
// //               No certificates generated yet.
// //             </p>
// //           ) : (
// //             <>
// //               {/* Mobile Card View */}
// //               <div className="md:hidden space-y-4">
// //                 {certificates.map((cert) => (
// //                   <div
// //                     key={cert.certId}
// //                     className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow"
// //                   >
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">
// //                         Cert No.
// //                       </span>
// //                       <span className="text-sm font-semibold text-gray-900">
// //                         {cert.certNo}
// //                       </span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">
// //                         Student Name
// //                       </span>
// //                       <span className="text-sm font-semibold text-gray-900">
// //                         {cert.studentName}
// //                       </span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">
// //                         Branch
// //                       </span>
// //                       <span className="text-sm text-gray-700">
// //                         {cert.branch}
// //                       </span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">
// //                         Course
// //                       </span>
// //                       <span className="text-sm text-gray-700">
// //                         {cert.course}
// //                       </span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-3">
// //                       <span className="text-sm font-medium text-gray-500">
// //                         Awarded On
// //                       </span>
// //                       <span className="text-sm text-gray-700">
// //                         {cert.awardedOn}
// //                       </span>
// //                     </div>
// //                     <button
// //                       className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors text-sm"
// //                       onClick={() => onSelect(cert)}
// //                     >
// //                       View Certificate
// //                     </button>
// //                   </div>
// //                 ))}
// //               </div>

// //               {/* Desktop Table View */}
// //               <div className="hidden md:block overflow-x-auto">
// //                 <table className="min-w-full divide-y divide-gray-200">
// //                   <thead className="bg-gray-50">
// //                     <tr>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
// //                         Cert No.
// //                       </th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
// //                         Student Name
// //                       </th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
// //                         Branch
// //                       </th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
// //                         Course
// //                       </th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
// //                         Awarded On
// //                       </th>
// //                       <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
// //                         Action
// //                       </th>
// //                     </tr>
// //                   </thead>
// //                   <tbody className="bg-white divide-y divide-gray-200">
// //                     {certificates.map((cert) => (
// //                       <tr
// //                         key={cert.certId}
// //                         className="hover:bg-gray-50 transition-colors"
// //                       >
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
// //                           {cert.certNo}
// //                         </td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
// //                           {cert.studentName}
// //                         </td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
// //                           {cert.branch}
// //                         </td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
// //                           {cert.course}
// //                         </td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
// //                           {cert.awardedOn}
// //                         </td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
// //                           <button
// //                             className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md transition-colors text-sm"
// //                             onClick={() => onSelect(cert)}
// //                           >
// //                             View
// //                           </button>
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             </>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default CertificateList;















// // import React, { useEffect, useState } from "react";

// // const CertificateList = ({ onSelect, onEdit }) => {
// //   const [certificates, setCertificates] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [deletingId, setDeletingId] = useState(null);

// //   useEffect(() => {
// //     const load = async () => {
// //       try {
// //         const res = await fetch("/api/certificates");
// //         if (!res.ok) throw new Error("Failed to load certificates");
// //         const data = await res.json();
// //         setCertificates(data);
// //       } catch (err) {
// //         setError(err.message || "Something went wrong.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     load();
// //   }, []);

// //   const handleDelete = async (certId) => {
// //     if (!window.confirm("Delete this certificate? This cannot be undone.")) return;
// //     setDeletingId(certId);
// //     try {
// //       const res = await fetch(`/api/certificates/${certId}`, { method: "DELETE" });
// //       if (!res.ok) throw new Error("Failed to delete certificate");
// //       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
// //     } catch (err) {
// //       setError(err.message || "Failed to delete certificate.");
// //     } finally {
// //       setDeletingId(null);
// //     }
// //   };

// //   if (loading)
// //     return (
// //       <div className="card ctm-border-radius shadow-sm">
// //         <div className="card-body">Loading...</div>
// //       </div>
// //     );
// //   if (error) return <div className="alert alert-danger">{error}</div>;

// //   return (
// //     <div className="w-full px-4 py-6">
// //       <div className="bg-white rounded-lg shadow-md overflow-hidden">
// //         <div className="p-4 md:p-6">
// //           <h4 className="text-gray-800 text-xl font-semibold mb-4 md:mb-6">All Certificates</h4>

// //           {certificates.length === 0 ? (
// //             <p className="text-gray-500 text-center py-8">No certificates generated yet.</p>
// //           ) : (
// //             <>
// //               {/* Mobile Card View */}
// //               <div className="md:hidden space-y-4">
// //                 {certificates.map((cert) => (
// //                   <div key={cert.certId} className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow">
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Cert No.</span>
// //                       <span className="text-sm font-semibold text-gray-900">{cert.certNo}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Student Name</span>
// //                       <span className="text-sm font-semibold text-gray-900">{cert.studentName}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Branch</span>
// //                       <span className="text-sm text-gray-700">{cert.branch}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Course</span>
// //                       <span className="text-sm text-gray-700">{cert.course}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-3">
// //                       <span className="text-sm font-medium text-gray-500">Awarded On</span>
// //                       <span className="text-sm text-gray-700">{cert.awardedOn}</span>
// //                     </div>
// //                     <div className="flex gap-2">
// //                       <button
// //                         className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors text-sm"
// //                         onClick={() => onSelect(cert)}
// //                       >
// //                         View
// //                       </button>
// //                       <button
// //                         className="flex-1 bg-amber-500 hover:bg-amber-600 text-white font-medium py-2 px-4 rounded-md transition-colors text-sm"
// //                         onClick={() => onEdit(cert)}
// //                       >
// //                         Edit
// //                       </button>
// //                       <button
// //                         className="flex-1 bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded-md transition-colors text-sm disabled:opacity-50"
// //                         onClick={() => handleDelete(cert.certId)}
// //                         disabled={deletingId === cert.certId}
// //                       >
// //                         {deletingId === cert.certId ? "..." : "Delete"}
// //                       </button>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>

// //               {/* Desktop Table View */}
// //               <div className="hidden md:block overflow-x-auto">
// //                 <table className="min-w-full divide-y divide-gray-200">
// //                   <thead className="bg-gray-50">
// //                     <tr>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cert No.</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Student Name</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Branch</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Course</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Awarded On</th>
// //                       <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody className="bg-white divide-y divide-gray-200">
// //                     {certificates.map((cert) => (
// //                       <tr key={cert.certId} className="hover:bg-gray-50 transition-colors">
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{cert.certNo}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.studentName}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.branch}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.course}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.awardedOn}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
// //                           <div className="flex gap-2 justify-end">
// //                             <button className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-md transition-colors text-sm" onClick={() => onSelect(cert)}>
// //                               View
// //                             </button>
// //                             <button className="bg-amber-500 hover:bg-amber-600 text-white px-3 py-2 rounded-md transition-colors text-sm" onClick={() => onEdit(cert)}>
// //                               Edit
// //                             </button>
// //                             <button
// //                               className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-md transition-colors text-sm disabled:opacity-50"
// //                               onClick={() => handleDelete(cert.certId)}
// //                               disabled={deletingId === cert.certId}
// //                             >
// //                               {deletingId === cert.certId ? "..." : "Delete"}
// //                             </button>
// //                           </div>
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             </>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default CertificateList;














// // ////sagar
// // import React, { useEffect, useState } from "react";

// // const StudentDetailsModal = ({ cert, onClose }) => {
// //   if (!cert) return null;

// //   const rows = [
// //     ["Certificate No.", cert.certNo],
// //     ["Student Name", cert.studentName],
// //     ["Father's Name", cert.fatherName],
// //     ["Branch", cert.branch],
// //     ["Course / Training", cert.course],
// //     ["Training Centre", cert.centre],
// //     ["College", cert.college],
// //     ["Qualification", cert.qualification],
// //     ["Date of Birth", cert.dob],
// //     ["Email ID", cert.email],
// //     ["Mobile No.", cert.mobile],
// //     ["Contact Address", cert.address],
// //     ["Start Date", cert.startDate],
// //     ["End Date", cert.endDate],
// //     ["Awarded On", cert.awardedOn],
// //   ];

// //   return (
// //     <div
// //       className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
// //       onClick={onClose}
// //     >
// //       <div
// //         className="bg-white rounded-lg shadow-lg max-w-lg w-full max-h-[85vh] overflow-y-auto"
// //         onClick={(e) => e.stopPropagation()}
// //       >
// //         <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
// //           <h4 className="text-lg font-semibold text-gray-800">Student Details</h4>
// //           <button
// //             className="text-gray-400 hover:text-gray-700 text-xl leading-none"
// //             onClick={onClose}
// //           >
// //             &times;
// //           </button>
// //         </div>

// //         <div className="px-6 py-4 space-y-3">
// //           {rows.map(([label, value]) => (
// //             <div key={label} className="flex justify-between border-b border-gray-100 pb-2">
// //               <span className="text-sm font-medium text-gray-500">{label}</span>
// //               <span className="text-sm text-gray-800 text-right ml-4">{value || "—"}</span>
// //             </div>
// //           ))}
// //         </div>

// //         <div className="px-6 py-4 border-t border-gray-200 text-right">
// //           <button
// //             className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-md transition-colors text-sm"
// //             onClick={onClose}
// //           >
// //             Close
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // const CertificateList = ({ onSelect, onEdit }) => {
// //   const [certificates, setCertificates] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [deletingId, setDeletingId] = useState(null);
// //   const [detailsCert, setDetailsCert] = useState(null); // cert shown in the details modal

// //   useEffect(() => {
// //     const load = async () => {
// //       try {
// //         const res = await fetch("/api/certificates");
// //         if (!res.ok) throw new Error("Failed to load certificates");
// //         const data = await res.json();
// //         setCertificates(data);
// //       } catch (err) {
// //         setError(err.message || "Something went wrong.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     load();
// //   }, []);

// //   const handleDelete = async (certId) => {
// //     if (!window.confirm("Delete this certificate? This cannot be undone.")) return;
// //     setDeletingId(certId);
// //     try {
// //       const res = await fetch(`/api/certificates/${certId}`, { method: "DELETE" });
// //       if (!res.ok) throw new Error("Failed to delete certificate");
// //       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
// //     } catch (err) {
// //       setError(err.message || "Failed to delete certificate.");
// //     } finally {
// //       setDeletingId(null);
// //     }
// //   };

// //   if (loading)
// //     return (
// //       <div className="card ctm-border-radius shadow-sm">
// //         <div className="card-body">Loading...</div>
// //       </div>
// //     );
// //   if (error) return <div className="alert alert-danger">{error}</div>;

// //   return (
// //     <div className="w-full px-4 py-6">
// //       <div className="bg-white rounded-lg shadow-md overflow-hidden">
// //         <div className="p-4 md:p-6">
// //           <h4 className="text-gray-800 text-xl font-semibold mb-4 md:mb-6">All Certificates</h4>

// //           {certificates.length === 0 ? (
// //             <p className="text-gray-500 text-center py-8">No certificates generated yet.</p>
// //           ) : (
// //             <>
// //               {/* Mobile Card View */}
// //               <div className="md:hidden space-y-4">
// //                 {certificates.map((cert) => (
// //                   <div key={cert.certId} className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow">
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Cert No.</span>
// //                       <span className="text-sm font-semibold text-gray-900">{cert.certNo}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Student Name</span>
// //                       <span className="text-sm font-semibold text-gray-900">{cert.studentName}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Branch</span>
// //                       <span className="text-sm text-gray-700">{cert.branch}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Course</span>
// //                       <span className="text-sm text-gray-700">{cert.course}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-3">
// //                       <span className="text-sm font-medium text-gray-500">Awarded On</span>
// //                       <span className="text-sm text-gray-700">{cert.awardedOn}</span>
// //                     </div>
// //                     <div className="flex gap-2 flex-wrap">
// //                       <button
// //                         className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm"
// //                         onClick={() => onSelect(cert)}
// //                       >
// //                         View
// //                       </button>
// //                       <button
// //                         className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm"
// //                         onClick={() => setDetailsCert(cert)}
// //                       >
// //                         View Details
// //                       </button>
// //                       <button
// //                         className="flex-1 bg-amber-500 hover:bg-amber-600 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm"
// //                         onClick={() => onEdit(cert)}
// //                       >
// //                         Edit
// //                       </button>
// //                       <button
// //                         className="flex-1 bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm disabled:opacity-50"
// //                         onClick={() => handleDelete(cert.certId)}
// //                         disabled={deletingId === cert.certId}
// //                       >
// //                         {deletingId === cert.certId ? "..." : "Delete"}
// //                       </button>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>

// //               {/* Desktop Table View */}
// //               <div className="hidden md:block overflow-x-auto">
// //                 <table className="min-w-full divide-y divide-gray-200">
// //                   <thead className="bg-gray-50">
// //                     <tr>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cert No.</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Student Name</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Branch</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Course</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Awarded On</th>
// //                       <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody className="bg-white divide-y divide-gray-200">
// //                     {certificates.map((cert) => (
// //                       <tr key={cert.certId} className="hover:bg-gray-50 transition-colors">
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{cert.certNo}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.studentName}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.branch}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.course}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.awardedOn}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
// //                           <div className="flex gap-2 justify-end">
// //                             <button className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-md transition-colors text-sm" onClick={() => onSelect(cert)}>
// //                               View
// //                             </button>
// //                             <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-md transition-colors text-sm" onClick={() => setDetailsCert(cert)}>
// //                               View Details
// //                             </button>
// //                             <button className="bg-amber-500 hover:bg-amber-600 text-white px-3 py-2 rounded-md transition-colors text-sm" onClick={() => onEdit(cert)}>
// //                               Edit
// //                             </button>
// //                             <button
// //                               className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-md transition-colors text-sm disabled:opacity-50"
// //                               onClick={() => handleDelete(cert.certId)}
// //                               disabled={deletingId === cert.certId}
// //                             >
// //                               {deletingId === cert.certId ? "..." : "Delete"}
// //                             </button>
// //                           </div>
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             </>
// //           )}
// //         </div>
// //       </div>

// //       <StudentDetailsModal cert={detailsCert} onClose={() => setDetailsCert(null)} />
// //     </div>
// //   );
// // };

// // export default CertificateList;








// // ///////
// // ////sagar
// // import React, { useEffect, useState } from "react";

// // const StudentDetailsPanel = ({ cert, onClose }) => {
// //   if (!cert) return null;

// //   const rows = [
// //     ["Certificate No.", cert.certNo],
// //     ["Student Name", cert.studentName],
// //     ["Father's Name", cert.fatherName],
// //     ["Branch", cert.branch],
// //     ["Course / Training", cert.course],
// //     ["Training Centre", cert.centre],
// //     ["College", cert.college],
// //     ["Qualification", cert.qualification],
// //     ["Date of Birth", cert.dob],
// //     ["Email ID", cert.email],
// //     ["Mobile No.", cert.mobile],
// //     ["Contact Address", cert.address],
// //     ["Start Date", cert.startDate],
// //     ["End Date", cert.endDate],
// //     ["Awarded On", cert.awardedOn],
// //   ];

// //   return (
// //     <div className="mb-6 bg-emerald-50 border border-emerald-200 rounded-lg overflow-hidden">
// //       <div className="flex justify-between items-center px-6 py-4 border-b border-emerald-200 bg-emerald-100">
// //         <h4 className="text-lg font-semibold text-gray-800">
// //           Student Details — {cert.studentName}
// //         </h4>
// //         <button
// //           className="text-gray-500 hover:text-gray-800 text-sm font-medium"
// //           onClick={onClose}
// //         >
// //           Close ✕
// //         </button>
// //       </div>

// //       <div className="px-6 py-4 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3">
// //         {rows.map(([label, value]) => (
// //           <div key={label} className="flex justify-between border-b border-emerald-100 pb-2">
// //             <span className="text-sm font-medium text-gray-500">{label}</span>
// //             <span className="text-sm text-gray-800 text-right ml-4">{value || "—"}</span>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // const CertificateList = ({ onSelect, onEdit }) => {
// //   const [certificates, setCertificates] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [deletingId, setDeletingId] = useState(null);
// //   const [detailsCert, setDetailsCert] = useState(null); // cert shown in the inline details panel

// //   useEffect(() => {
// //     const load = async () => {
// //       try {
// //         const res = await fetch("/api/certificates");
// //         if (!res.ok) throw new Error("Failed to load certificates");
// //         const data = await res.json();
// //         setCertificates(data);
// //       } catch (err) {
// //         setError(err.message || "Something went wrong.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     load();
// //   }, []);

// //   const handleDelete = async (certId) => {
// //     if (!window.confirm("Delete this certificate? This cannot be undone.")) return;
// //     setDeletingId(certId);
// //     try {
// //       const res = await fetch(`/api/certificates/${certId}`, { method: "DELETE" });
// //       if (!res.ok) throw new Error("Failed to delete certificate");
// //       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
// //       if (detailsCert && detailsCert.certId === certId) setDetailsCert(null);
// //     } catch (err) {
// //       setError(err.message || "Failed to delete certificate.");
// //     } finally {
// //       setDeletingId(null);
// //     }
// //   };

// //   const handleViewDetails = (cert) => {
// //     // toggle: clicking the same row's button again closes it
// //     setDetailsCert((prev) => (prev && prev.certId === cert.certId ? null : cert));
// //   };

// //   if (loading)
// //     return (
// //       <div className="card ctm-border-radius shadow-sm">
// //         <div className="card-body">Loading...</div>
// //       </div>
// //     );
// //   if (error) return <div className="alert alert-danger">{error}</div>;

// //   return (
// //     <div className="w-full px-4 py-6">
// //       <div className="bg-white rounded-lg shadow-md overflow-hidden">
// //         <div className="p-4 md:p-6">
// //           <h4 className="text-gray-800 text-xl font-semibold mb-4 md:mb-6">All Certificates</h4>

// //           {/* Inline details panel — shows right here on the page, no popup */}
// //           <StudentDetailsPanel cert={detailsCert} onClose={() => setDetailsCert(null)} />

// //           {certificates.length === 0 ? (
// //             <p className="text-gray-500 text-center py-8">No certificates generated yet.</p>
// //           ) : (
// //             <>
// //               {/* Mobile Card View */}
// //               <div className="md:hidden space-y-4">
// //                 {certificates.map((cert) => (
// //                   <div key={cert.certId} className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow">
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Cert No.</span>
// //                       <span className="text-sm font-semibold text-gray-900">{cert.certNo}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Student Name</span>
// //                       <span className="text-sm font-semibold text-gray-900">{cert.studentName}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Branch</span>
// //                       <span className="text-sm text-gray-700">{cert.branch}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Course</span>
// //                       <span className="text-sm text-gray-700">{cert.course}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-3">
// //                       <span className="text-sm font-medium text-gray-500">Awarded On</span>
// //                       <span className="text-sm text-gray-700">{cert.awardedOn}</span>
// //                     </div>
// //                     <div className="flex gap-2 flex-wrap">
// //                       <button
// //                         className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm"
// //                         onClick={() => onSelect(cert)}
// //                       >
// //                         View
// //                       </button>
// //                       <button
// //                         className={`flex-1 font-medium py-2 px-3 rounded-md transition-colors text-sm text-white ${
// //                           detailsCert && detailsCert.certId === cert.certId
// //                             ? "bg-emerald-800 hover:bg-emerald-900"
// //                             : "bg-emerald-600 hover:bg-emerald-700"
// //                         }`}
// //                         onClick={() => handleViewDetails(cert)}
// //                       >
// //                         {detailsCert && detailsCert.certId === cert.certId ? "Hide Details" : "View Details"}
// //                       </button>
// //                       <button
// //                         className="flex-1 bg-amber-500 hover:bg-amber-600 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm"
// //                         onClick={() => onEdit(cert)}
// //                       >
// //                         Edit
// //                       </button>
// //                       <button
// //                         className="flex-1 bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm disabled:opacity-50"
// //                         onClick={() => handleDelete(cert.certId)}
// //                         disabled={deletingId === cert.certId}
// //                       >
// //                         {deletingId === cert.certId ? "..." : "Delete"}
// //                       </button>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>

// //               {/* Desktop Table View */}
// //               <div className="hidden md:block overflow-x-auto">
// //                 <table className="min-w-full divide-y divide-gray-200">
// //                   <thead className="bg-gray-50">
// //                     <tr>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cert No.</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Student Name</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Branch</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Course</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Awarded On</th>
// //                       <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody className="bg-white divide-y divide-gray-200">
// //                     {certificates.map((cert) => (
// //                       <tr key={cert.certId} className="hover:bg-gray-50 transition-colors">
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{cert.certNo}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.studentName}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.branch}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.course}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.awardedOn}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
// //                           <div className="flex gap-2 justify-end">
// //                             <button className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-md transition-colors text-sm" onClick={() => onSelect(cert)}>
// //                               View
// //                             </button>
// //                             <button
// //                               className={`px-3 py-2 rounded-md transition-colors text-sm text-white ${
// //                                 detailsCert && detailsCert.certId === cert.certId
// //                                   ? "bg-emerald-800 hover:bg-emerald-900"
// //                                   : "bg-emerald-600 hover:bg-emerald-700"
// //                               }`}
// //                               onClick={() => handleViewDetails(cert)}
// //                             >
// //                               {detailsCert && detailsCert.certId === cert.certId ? "Hide Details" : "View Details"}
// //                             </button>
// //                             <button className="bg-amber-500 hover:bg-amber-600 text-white px-3 py-2 rounded-md transition-colors text-sm" onClick={() => onEdit(cert)}>
// //                               Edit
// //                             </button>
// //                             <button
// //                               className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-md transition-colors text-sm disabled:opacity-50"
// //                               onClick={() => handleDelete(cert.certId)}
// //                               disabled={deletingId === cert.certId}
// //                             >
// //                               {deletingId === cert.certId ? "..." : "Delete"}
// //                             </button>
// //                           </div>
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             </>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default CertificateList;



























// // import React, { useEffect, useState } from "react";

// // const StudentDetailsPanel = ({ cert, onClose }) => {
// //   if (!cert) return null;

// //   const rows = [
// //     ["Certificate No.", cert.certNo],
// //     ["Student Name", cert.studentName],
// //     ["Father's Name", cert.fatherName],
// //     ["Branch", cert.branch],
// //     ["Course / Training", cert.course],
// //     ["Training Centre", cert.centre],
// //     ["College", cert.college],
// //     ["Qualification", cert.qualification],
// //     ["Date of Birth", cert.dob],
// //     ["Email ID", cert.email],
// //     ["Mobile No.", cert.mobile],
// //     ["Contact Address", cert.address],
// //     ["Start Date", cert.startDate],
// //     ["End Date", cert.endDate],
// //     ["Awarded On", cert.awardedOn],
// //   ];

// //   return (
// //     <div className="mb-6 bg-emerald-50 border border-emerald-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
// //       <div className="flex flex-wrap gap-2 justify-between items-center px-4 sm:px-6 py-4 border-b border-emerald-200 bg-emerald-100">
// //         <h4 className="text-base sm:text-lg font-semibold text-gray-800 break-words">
// //           Student Details — {cert.studentName}
// //         </h4>
// //         <button
// //           className="text-gray-500 hover:text-gray-800 text-sm font-medium bg-white/60 hover:bg-white px-3 py-1 rounded-md transition-colors shrink-0"
// //           onClick={onClose}
// //         >
// //           Close ✕
// //         </button>
// //       </div>

// //       <div className="px-4 sm:px-6 py-5 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
// //         {rows.map(([label, value]) => (
// //           <div key={label} className="flex flex-wrap justify-between items-center gap-x-4 gap-y-1 border-b border-emerald-100 pb-2">
// //             <span className="text-sm font-medium text-gray-500">{label}</span>
// //             <span className="text-sm text-gray-800 text-right ml-auto break-words max-w-[70%]">{value || "—"}</span>
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // const CertificateList = ({ onSelect, onEdit }) => {
// //   const [certificates, setCertificates] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [deletingId, setDeletingId] = useState(null);
// //   const [detailsCert, setDetailsCert] = useState(null); // cert shown in the inline details panel
// //   const [searchTerm, setSearchTerm] = useState(""); // search bar input

// //   useEffect(() => {
// //     const load = async () => {
// //       try {
// //         const res = await fetch("/api/certificates");
// //         if (!res.ok) throw new Error("Failed to load certificates");
// //         const data = await res.json();
// //         setCertificates(data);
// //       } catch (err) {
// //         setError(err.message || "Something went wrong.");
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     load();
// //   }, []);

// //   const handleDelete = async (certId) => {
// //     if (!window.confirm("Delete this certificate? This cannot be undone.")) return;
// //     setDeletingId(certId);
// //     try {
// //       const res = await fetch(`/api/certificates/${certId}`, { method: "DELETE" });
// //       if (!res.ok) throw new Error("Failed to delete certificate");
// //       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
// //       if (detailsCert && detailsCert.certId === certId) setDetailsCert(null);
// //     } catch (err) {
// //       setError(err.message || "Failed to delete certificate.");
// //     } finally {
// //       setDeletingId(null);
// //     }
// //   };

// //   const handleViewDetails = (cert) => {
// //     // toggle: clicking the same row's button again closes it
// //     setDetailsCert((prev) => (prev && prev.certId === cert.certId ? null : cert));
// //   };

// //   // Filter certificates on the client side based on the search term.
// //   // Matches against cert no, student name, branch and course.
// //   const filteredCertificates = certificates.filter((cert) => {
// //     const term = searchTerm.trim().toLowerCase();
// //     if (!term) return true;
// //     return (
// //       (cert.certNo || "").toLowerCase().includes(term) ||
// //       (cert.studentName || "").toLowerCase().includes(term) ||
// //       (cert.branch || "").toLowerCase().includes(term) ||
// //       (cert.course || "").toLowerCase().includes(term)
// //     );
// //   });

// //   if (loading)
// //     return (
// //       <div className="card ctm-border-radius shadow-sm">
// //         <div className="card-body">Loading...</div>
// //       </div>
// //     );
// //   if (error) return <div className="alert alert-danger">{error}</div>;

// //   return (
// //     <div className="w-full px-4 py-6">
// //       <div className="bg-white rounded-lg shadow-md overflow-hidden">
// //         <div className="p-4 md:p-6">
// //           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 md:mb-6">
// //             <h4 className="text-gray-800 text-lg sm:text-xl font-semibold">All Certificates</h4>

// //             {/* Search bar */}
// //             <div className="relative w-full sm:w-64 md:w-80">
// //               <span
// //                 className="absolute inset-y-0 left-0 flex items-center justify-center pl-3 text-gray-400 pointer-events-none"
// //                 style={{ width: "2rem" }}
// //               >
// //                 <svg
// //                   xmlns="http://www.w3.org/2000/svg"
// //                   width="16"
// //                   height="16"
// //                   viewBox="0 0 24 24"
// //                   fill="none"
// //                   stroke="currentColor"
// //                   strokeWidth="2"
// //                   strokeLinecap="round"
// //                   strokeLinejoin="round"
// //                   style={{ width: "16px", height: "16px", flexShrink: 0 }}
// //                 >
// //                   <circle cx="11" cy="11" r="8" />
// //                   <line x1="21" y1="21" x2="16.65" y2="16.65" />
// //                 </svg>
// //               </span>
// //               <input
// //                 type="text"
// //                 value={searchTerm}
// //                 onChange={(e) => setSearchTerm(e.target.value)}
// //                 placeholder="Search by name, cert no, branch, course..."
// //                 className="w-full pl-9 pr-8 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
// //               />
// //               {searchTerm && (
// //                 <button
// //                   onClick={() => setSearchTerm("")}
// //                   className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 text-sm leading-none"
// //                   aria-label="Clear search"
// //                 >
// //                   ✕
// //                 </button>
// //               )}
// //             </div>
// //           </div>

// //           {/* Inline details panel — shows right here on the page, no popup */}
// //           <StudentDetailsPanel cert={detailsCert} onClose={() => setDetailsCert(null)} />

// //           {certificates.length === 0 ? (
// //             <p className="text-gray-500 text-center py-8">No certificates generated yet.</p>
// //           ) : filteredCertificates.length === 0 ? (
// //             <p className="text-gray-500 text-center py-8">No certificates match your search.</p>
// //           ) : (
// //             <>
// //               {/* Mobile Card View */}
// //               <div className="md:hidden space-y-4">
// //                 {filteredCertificates.map((cert) => (
// //                   <div key={cert.certId} className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow">
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Cert No.</span>
// //                       <span className="text-sm font-semibold text-gray-900">{cert.certNo}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Student Name</span>
// //                       <span className="text-sm font-semibold text-gray-900">{cert.studentName}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Branch</span>
// //                       <span className="text-sm text-gray-700">{cert.branch}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-2">
// //                       <span className="text-sm font-medium text-gray-500">Course</span>
// //                       <span className="text-sm text-gray-700">{cert.course}</span>
// //                     </div>
// //                     <div className="flex justify-between items-start mb-3">
// //                       <span className="text-sm font-medium text-gray-500">Awarded On</span>
// //                       <span className="text-sm text-gray-700">{cert.awardedOn}</span>
// //                     </div>
// //                     <div className="grid grid-cols-2 gap-2 sm:gap-3">
// //                       <button
// //                         className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm"
// //                         onClick={() => onSelect(cert)}
// //                       >
// //                         View
// //                       </button>
// //                       <button
// //                         className={`w-full font-medium py-2 px-3 rounded-md transition-colors text-sm text-white ${
// //                           detailsCert && detailsCert.certId === cert.certId
// //                             ? "bg-emerald-800 hover:bg-emerald-900"
// //                             : "bg-emerald-600 hover:bg-emerald-700"
// //                         }`}
// //                         onClick={() => handleViewDetails(cert)}
// //                       >
// //                         {detailsCert && detailsCert.certId === cert.certId ? "Hide Details" : "View Details"}
// //                       </button>
// //                       <button
// //                         className="w-full bg-amber-500 hover:bg-amber-600 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm"
// //                         onClick={() => onEdit(cert)}
// //                       >
// //                         Edit
// //                       </button>
// //                       <button
// //                         className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm disabled:opacity-50"
// //                         onClick={() => handleDelete(cert.certId)}
// //                         disabled={deletingId === cert.certId}
// //                       >
// //                         {deletingId === cert.certId ? "..." : "Delete"}
// //                       </button>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>

// //               {/* Desktop Table View */}
// //               <div className="hidden md:block overflow-x-auto">
// //                 <table className="min-w-full divide-y divide-gray-200">
// //                   <thead className="bg-gray-50">
// //                     <tr>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cert No.</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Student Name</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Branch</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Course</th>
// //                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Awarded On</th>
// //                       <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody className="bg-white divide-y divide-gray-200">
// //                     {filteredCertificates.map((cert) => (
// //                       <tr key={cert.certId} className="hover:bg-gray-50 transition-colors">
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{cert.certNo}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.studentName}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.branch}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.course}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.awardedOn}</td>
// //                         <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
// //                           <div className="flex flex-wrap gap-2 lg:gap-3 justify-end">
// //                             <button className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-md transition-colors text-sm whitespace-nowrap" onClick={() => onSelect(cert)}>
// //                               View
// //                             </button>
// //                             <button
// //                               className={`px-3 py-2 rounded-md transition-colors text-sm text-white whitespace-nowrap ${
// //                                 detailsCert && detailsCert.certId === cert.certId
// //                                   ? "bg-emerald-800 hover:bg-emerald-900"
// //                                   : "bg-emerald-600 hover:bg-emerald-700"
// //                               }`}
// //                               onClick={() => handleViewDetails(cert)}
// //                             >
// //                               {detailsCert && detailsCert.certId === cert.certId ? "Hide Details" : "View Details"}
// //                             </button>
// //                             <button className="bg-amber-500 hover:bg-amber-600 text-white px-3 py-2 rounded-md transition-colors text-sm whitespace-nowrap" onClick={() => onEdit(cert)}>
// //                               Edit
// //                             </button>
// //                             <button
// //                               className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-md transition-colors text-sm whitespace-nowrap disabled:opacity-50"
// //                               onClick={() => handleDelete(cert.certId)}
// //                               disabled={deletingId === cert.certId}
// //                             >
// //                               {deletingId === cert.certId ? "..." : "Delete"}
// //                             </button>
// //                           </div>
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             </>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default CertificateList;















// // ///demo
// import React, { useEffect, useState } from "react";

// const StudentDetailsPanel = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Date of Birth", cert.dob],
//     ["Email ID", cert.email],
//     ["Mobile No.", cert.mobile],
//     ["Contact Address", cert.address],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   return (
//     <div className="mb-6 bg-emerald-50 border border-emerald-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
//       <div className="flex flex-wrap gap-2 justify-between items-center px-4 sm:px-6 py-4 border-b border-emerald-200 bg-emerald-100">
//         <h4 className="text-base sm:text-lg font-semibold text-gray-800 break-words">
//           Student Details — {cert.studentName}
//         </h4>
//         <button
//           className="text-gray-500 hover:text-gray-800 text-sm font-medium bg-white/60 hover:bg-white px-3 py-1 rounded-md transition-colors shrink-0"
//           onClick={onClose}
//         >
//           Close ✕
//         </button>
//       </div>

//       <div className="px-4 sm:px-6 py-5 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
//         {rows.map(([label, value]) => (
//           <div key={label} className="flex flex-wrap justify-between items-center gap-x-4 gap-y-1 border-b border-emerald-100 pb-2">
//             <span className="text-sm font-medium text-gray-500">{label}</span>
//             <span className="text-sm text-gray-800 text-right ml-auto break-words max-w-[70%]">{value || "—"}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// const CertificateViewPanel = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   return (
//     <div className="mb-6 bg-blue-50 border border-blue-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
//       <div className="flex flex-wrap gap-2 justify-between items-center px-4 sm:px-6 py-4 border-b border-blue-200 bg-blue-100">
//         <h4 className="text-base sm:text-lg font-semibold text-gray-800 break-words">
//           Certificate — {cert.studentName}
//         </h4>
//         <button
//           className="text-gray-500 hover:text-gray-800 text-sm font-medium bg-white/60 hover:bg-white px-3 py-1 rounded-md transition-colors shrink-0"
//           onClick={onClose}
//         >
//           Close ✕
//         </button>
//       </div>

//       <div className="px-4 sm:px-6 py-6 flex justify-center">
//         <div className="w-full max-w-2xl bg-white border-4 border-double border-blue-300 rounded-lg p-6 sm:p-10 text-center">
//           <p className="text-xs sm:text-sm uppercase tracking-widest text-gray-500 mb-2">Certificate of Completion</p>
//           <p className="text-xl sm:text-2xl font-bold text-gray-800 mb-1">{cert.studentName || "—"}</p>
//           <p className="text-sm text-gray-500 mb-6">Cert No. {cert.certNo || "—"}</p>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-left mt-4">
//             {rows.map(([label, value]) => (
//               <div key={label} className="flex justify-between border-b border-gray-100 pb-2">
//                 <span className="text-xs sm:text-sm font-medium text-gray-500">{label}</span>
//                 <span className="text-xs sm:text-sm text-gray-800 text-right ml-4 break-words">{value || "—"}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className="px-4 sm:px-6 pb-5 flex justify-center">
//         <button
//           className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2 px-5 rounded-md transition-colors text-sm"
//           onClick={onClose}
//         >
//           ← Back to list
//         </button>
//       </div>
//     </div>
//   );
// };

// const CertificateList = ({ onSelect, onEdit }) => {
//   const [certificates, setCertificates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deletingId, setDeletingId] = useState(null);
//   const [detailsCert, setDetailsCert] = useState(null); // cert shown in the inline details panel
//   const [viewingCert, setViewingCert] = useState(null); // cert shown in the inline certificate view panel
//   const [searchTerm, setSearchTerm] = useState(""); // search bar input

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await fetch("/api/certificates");
//         if (!res.ok) throw new Error("Failed to load certificates");
//         const data = await res.json();
//         setCertificates(data);
//       } catch (err) {
//         setError(err.message || "Something went wrong.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   const handleDelete = async (certId) => {
//     if (!window.confirm("Delete this certificate? This cannot be undone.")) return;
//     setDeletingId(certId);
//     try {
//       const res = await fetch(`/api/certificates/${certId}`, { method: "DELETE" });
//       if (!res.ok) throw new Error("Failed to delete certificate");
//       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
//       if (detailsCert && detailsCert.certId === certId) setDetailsCert(null);
//       if (viewingCert && viewingCert.certId === certId) setViewingCert(null);
//     } catch (err) {
//       setError(err.message || "Failed to delete certificate.");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   const handleViewDetails = (cert) => {
//     // toggle: clicking the same row's button again closes it
//     setDetailsCert((prev) => (prev && prev.certId === cert.certId ? null : cert));
//   };

//   const handleView = (cert) => {
//     // Show the certificate inline, right here in the list, with its own Close button.
//     setViewingCert((prev) => (prev && prev.certId === cert.certId ? null : cert));
//     // Still notify the parent in case it needs to know (e.g. for analytics/logging).
//     // This does not change the parent's own rendering, so the list always stays visible.
//     if (typeof onSelect === "function") onSelect(cert);
//   };

//   // Filter certificates on the client side based on the search term.
//   // Checks every text/number field on the certificate object, so it keeps
//   // working even if the field holding the name isn't literally "studentName".
//   const filteredCertificates = certificates.filter((cert) => {
//     const term = searchTerm.trim().toLowerCase();
//     if (!term) return true;
//     return Object.values(cert || {}).some((val) => {
//       if (val === null || val === undefined) return false;
//       if (typeof val === "string" || typeof val === "number") {
//         return String(val).toLowerCase().includes(term);
//       }
//       return false;
//     });
//   });

//   if (loading)
//     return (
//       <div className="card ctm-border-radius shadow-sm">
//         <div className="card-body">Loading...</div>
//       </div>
//     );
//   if (error) return <div className="alert alert-danger">{error}</div>;

//   return (
//     <div className="w-full px-4 py-6">
//       <div className="bg-white rounded-lg shadow-md overflow-hidden">
//         <div className="p-4 md:p-6">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 md:mb-6">
//             <h4 className="text-gray-800 text-lg sm:text-xl font-semibold">All Certificates</h4>

//             {/* Search bar */}
//             <div className="relative w-full sm:w-64 md:w-80">
//               <span
//                 className="absolute inset-y-0 left-0 flex items-center justify-center pl-3 text-gray-400 pointer-events-none"
//                 style={{ width: "2rem" }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   style={{ width: "16px", height: "16px", flexShrink: 0 }}
//                 >
//                   <circle cx="11" cy="11" r="8" />
//                   <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                 </svg>
//               </span>
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search by name, cert no, branch, course..."
//                 className="w-full pl-9 pr-8 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//               />
//               {searchTerm && (
//                 <button
//                   onClick={() => setSearchTerm("")}
//                   className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 text-sm leading-none"
//                   aria-label="Clear search"
//                 >
//                   ✕
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Inline certificate view panel — shown when "View" is clicked */}
//           <CertificateViewPanel cert={viewingCert} onClose={() => setViewingCert(null)} />

//           {/* Inline details panel — shows right here on the page, no popup */}
//           <StudentDetailsPanel cert={detailsCert} onClose={() => setDetailsCert(null)} />

//           {certificates.length === 0 ? (
//             <p className="text-gray-500 text-center py-8">No certificates generated yet.</p>
//           ) : filteredCertificates.length === 0 ? (
//             <p className="text-gray-500 text-center py-8">No certificates match your search.</p>
//           ) : (
//             <>
//               {/* Mobile Card View */}
//               <div className="md:hidden space-y-4">
//                 {filteredCertificates.map((cert) => (
//                   <div key={cert.certId} className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow">
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-medium text-gray-500">Cert No. : </span>
//                       <span className="text-sm font-semibold text-gray-900">{cert.certNo}</span>
//                     </div>
//                     <div className="flex justify-between items-start mb-2">
//                      <b><span className="text-sm font-bold">Student Name : </span></b> 
//                       <span className="text-sm font-semibold text-gray-900">{cert.studentName}</span>
//                     </div>
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-medium text-gray-500">Branch : </span>
//                       <span className="text-sm text-gray-700">{cert.branch}</span>
//                     </div>
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-medium text-gray-500">Course : </span>
//                       <span className="text-sm text-gray-700">{cert.course}</span>
//                     </div>
//                     <div className="flex justify-between items-start mb-3">
//                       <span className="text-sm font-medium text-gray-500">Awarded On : </span>
//                       <span className="text-sm text-gray-700">{cert.awardedOn}</span>
//                     </div>
//                     <div className="grid grid-cols-2 gap-2 sm:gap-3">
//                       <button
//                         className={`w-full font-medium py-2 px-3 rounded-md transition-colors text-sm text-white ${
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "bg-blue-800 hover:bg-blue-900"
//                             : "bg-blue-600 hover:bg-blue-700"
//                         }`}
//                         onClick={() => handleView(cert)}
//                       >
//                         {viewingCert && viewingCert.certId === cert.certId ? "Hide" : "View"}
//                       </button>
//                       <button
//                         className={`w-full font-medium py-2 px-3 rounded-md transition-colors text-sm text-white ${
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "bg-emerald-800 hover:bg-emerald-900"
//                             : "bg-emerald-600 hover:bg-emerald-700"
//                         }`}
//                         onClick={() => handleViewDetails(cert)}
//                       >
//                         {detailsCert && detailsCert.certId === cert.certId ? "Hide Details" : "View Details"}
//                       </button>
//                       <button
//                         className="w-full bg-amber-500 hover:bg-amber-600 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm"
//                         onClick={() => onEdit(cert)}
//                       >
//                         Edit
//                       </button>
//                       <button
//                         className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-3 rounded-md transition-colors text-sm disabled:opacity-50"
//                         onClick={() => handleDelete(cert.certId)}
//                         disabled={deletingId === cert.certId}
//                       >
//                         {deletingId === cert.certId ? "..." : "Delete"}
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Desktop Table View */}
//               <div className="hidden md:block overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cert No.</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Student Name</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Branch</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Course</th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Awarded On</th>
//                       <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {filteredCertificates.map((cert) => (
//                       <tr key={cert.certId} className="hover:bg-gray-50 transition-colors">
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{cert.certNo}</td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.studentName}</td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.branch}</td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.course}</td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{cert.awardedOn}</td>
//                         <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
//                           <div className="flex flex-wrap gap-2 lg:gap-3 justify-end">
//                             <button
//                               className={`px-3 py-2 rounded-md transition-colors text-sm text-white whitespace-nowrap ${
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "bg-blue-800 hover:bg-blue-900"
//                                   : "bg-blue-600 hover:bg-blue-700"
//                               }`}
//                               onClick={() => handleView(cert)}
//                             >
//                               {viewingCert && viewingCert.certId === cert.certId ? "Hide" : "View"}
//                             </button>
//                             <button
//                               className={`px-3 py-2 rounded-md transition-colors text-sm text-white whitespace-nowrap ${
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "bg-emerald-800 hover:bg-emerald-900"
//                                   : "bg-emerald-600 hover:bg-emerald-700"
//                               }`}
//                               onClick={() => handleViewDetails(cert)}
//                             >
//                               {detailsCert && detailsCert.certId === cert.certId ? "Hide Details" : "View Details"}
//                             </button>
//                             <button className="bg-amber-500 hover:bg-amber-600 text-white px-3 py-2 rounded-md transition-colors text-sm whitespace-nowrap" onClick={() => onEdit(cert)}>
//                               Edit
//                             </button>
//                             <button
//                               className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-md transition-colors text-sm whitespace-nowrap disabled:opacity-50"
//                               onClick={() => handleDelete(cert.certId)}
//                               disabled={deletingId === cert.certId}
//                             >
//                               {deletingId === cert.certId ? "..." : "Delete"}
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CertificateList;













// // ///demo
// import React, { useEffect, useState } from "react";

// const StudentDetailsPanel = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Date of Birth", cert.dob],
//     ["Email ID", cert.email],
//     ["Mobile No.", cert.mobile],
//     ["Contact Address", cert.address],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   return (
//     <div className="mb-6 bg-emerald-50 border border-emerald-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
//       <div className="flex flex-wrap gap-2 justify-between items-center px-4 sm:px-6 py-4 border-b border-emerald-200 bg-emerald-100">
//         <h4 className="text-base sm:text-lg font-semibold text-gray-800 break-words">
//           Student Details — {cert.studentName}
//         </h4>
//         <button
//           className="text-gray-500 hover:text-gray-800 text-sm font-medium bg-white/60 hover:bg-white px-3 py-1 rounded-md transition-colors shrink-0"
//           onClick={onClose}
//         >
//           Close ✕
//         </button>
//       </div>

//       <div className="px-4 sm:px-6 py-5 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
//         {rows.map(([label, value]) => (
//           <div
//             key={label}
//             className="flex flex-wrap justify-between items-center gap-x-4 gap-y-1 border-b border-emerald-100 pb-2"
//           >
//             <span className="text-md font-bold  text-gray-800">{label}: </span>
//             <span className="text-md text-gray-800 text-right ml-auto break-words max-w-[70%]">
//               {value || "—"}
//             </span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// const CertificateViewPanel = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   return (
//     <div className="mb-6 bg-orange-50 border border-orange-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
//       <div className="flex flex-wrap gap-2 justify-between items-center px-4 sm:px-6 py-4 border-b border-orange-200 bg-orange-100">
//         <h4 className="text-base sm:text-lg font-semibold text-gray-800 break-words">
//           Certificate — {cert.studentName}
//         </h4>
//         <button
//           className="text-gray-500 hover:text-gray-800 text-sm font-medium bg-white/60 hover:bg-white px-3 py-1 rounded-md transition-colors shrink-0"
//           onClick={onClose}
//         >
//           Close ✕
//         </button>
//       </div>

//       <div className="px-4 sm:px-6 py-6 flex justify-center">
//         <div className="w-full max-w-2xl bg-white border-4 border-double border-orange-300 rounded-lg p-6 sm:p-10 text-center">
//           <p className="text-xs sm:text-sm uppercase tracking-widest text-gray-500 mb-2">
//             Certificate of Completion
//           </p>
//           <p className="text-xl sm:text-2xl font-bold text-gray-800 mb-1">
//             {cert.studentName || "—"}
//           </p>
//           <p className="text-sm text-gray-500 mb-6">
//             Cert No. {cert.certNo || "—"}
//           </p>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-left mt-4">
//             {rows.map(([label, value]) => (
//               <div
//                 key={label}
//                 className="flex justify-between border-b border-gray-100 pb-2"
//               >
//                 <span className="text-xs sm:text-sm font-medium text-gray-500">
//                   {label}
//                 </span>
//                 <span className="text-xs sm:text-sm text-gray-800 text-right ml-4 break-words">
//                   {value || "—"}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className="px-4 sm:px-6 pb-5 flex justify-center">
//         <button
//           className="bg-orange-500 hover:bg-orange-600 text-white font-medium py-2 px-5 rounded-md transition-colors text-sm"
//           onClick={onClose}
//         >
//           ← Back to list
//         </button>
//       </div>
//     </div>
//   );
// };

// const CertificateList = ({ onSelect, onEdit }) => {
//   const [certificates, setCertificates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deletingId, setDeletingId] = useState(null);
//   const [detailsCert, setDetailsCert] = useState(null);
//   const [viewingCert, setViewingCert] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await fetch("/api/certificates");
//         if (!res.ok) throw new Error("Failed to load certificates");
//         const data = await res.json();
//         setCertificates(data);
//       } catch (err) {
//         setError(err.message || "Something went wrong.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   const handleDelete = async (certId) => {
//     if (!window.confirm("Delete this certificate? This cannot be undone."))
//       return;
//     setDeletingId(certId);
//     try {
//       const res = await fetch(
//         `/api/certificates/${certId}`,
//         { method: "DELETE" },
//       );
//       if (!res.ok) throw new Error("Failed to delete certificate");
//       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
//       if (detailsCert && detailsCert.certId === certId) setDetailsCert(null);
//       if (viewingCert && viewingCert.certId === certId) setViewingCert(null);
//     } catch (err) {
//       setError(err.message || "Failed to delete certificate.");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   const handleViewDetails = (cert) => {
//     setDetailsCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//   };

//   const handleView = (cert) => {
//     setViewingCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//     if (typeof onSelect === "function") onSelect(cert);
//   };

//   const filteredCertificates = certificates.filter((cert) => {
//     const term = searchTerm.trim().toLowerCase();
//     if (!term) return true;
//     return Object.values(cert || {}).some((val) => {
//       if (val === null || val === undefined) return false;
//       if (typeof val === "string" || typeof val === "number") {
//         return String(val).toLowerCase().includes(term);
//       }
//       return false;
//     });
//   });

//   if (loading)
//     return (
//       <div className="card ctm-border-radius shadow-sm">
//         <div className="card-body">Loading...</div>
//       </div>
//     );
//   if (error) return <div className="alert alert-danger">{error}</div>;

//   return (
//     <div className="w-full px-4 py-6">
//       <div className="bg-white rounded-lg shadow-md overflow-hidden">
//         <div className="p-4 md:p-6">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 md:mb-6">
//             <h4 className="text-gray-800 text-lg sm:text-xl font-semibold">
//               All Certificates
//             </h4>

//             <div className="relative w-full sm:w-64 md:w-80">
//               <span
//                 className="absolute inset-y-0 left-0 flex items-center justify-center pl-3 text-gray-400 pointer-events-none"
//                 style={{ width: "2rem" }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   style={{ width: "16px", height: "16px", flexShrink: 0 }}
//                 >
//                   <circle cx="11" cy="11" r="8" />
//                   <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                 </svg>
//               </span>
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search by name, cert no, branch, course..."
//                 className="w-full pl-9 pr-8 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
//               />
//               {searchTerm && (
//                 <button
//                   onClick={() => setSearchTerm("")}
//                   className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 text-sm leading-none"
//                   aria-label="Clear search"
//                 >
//                   ✕
//                 </button>
//               )}
//             </div>
//           </div>

//           <CertificateViewPanel
//             cert={viewingCert}
//             onClose={() => setViewingCert(null)}
//           />

//           <StudentDetailsPanel
//             cert={detailsCert}
//             onClose={() => setDetailsCert(null)}
//           />

//           {certificates.length === 0 ? (
//             <p className="text-gray-500 text-center py-8">
//               No certificates generated yet.
//             </p>
//           ) : filteredCertificates.length === 0 ? (
//             <p className="text-gray-500 text-center py-8">
//               No certificates match your search.
//             </p>
//           ) : (
//             <>
//               {/* Mobile Card View */}
//               <div className="md:hidden space-y-4">
//                 {filteredCertificates.map((cert) => (
//                   <div
//                     key={cert.certId}
//                     className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow"
//                   >
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-bold text-gray-700">
//                         Cert No. :
//                       </span>
//                       <span className="text-sm font-semibold text-gray-900">
//                         {cert.certNo}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-bold text-gray-700">
//                         Student Name :
//                       </span>
//                       <span className="text-sm font-semibold text-gray-900">
//                         {cert.studentName}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-bold text-gray-700">
//                         Branch :
//                       </span>
//                       <span className="text-sm text-gray-700">
//                         {cert.branch}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-bold text-gray-700">
//                         Course :
//                       </span>
//                       <span className="text-sm text-gray-700">
//                         {cert.course}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-start mb-3">
//                       <span className="text-sm font-bold text-gray-700">
//                         Awarded On :
//                       </span>
//                       <span className="text-sm text-gray-700">
//                         {cert.awardedOn}
//                       </span>
//                     </div>
//                     <div
//                       style={{
//                         display: "grid",
//                         gridTemplateColumns: "1fr 1fr",
//                         gap: "8px",
//                       }}
//                     >
//                       <button
//                         style={{
//                           width: "100%",
//                           fontWeight: "500",
//                           padding: "10px 12px",
//                           borderRadius: "6px",
//                           transition: "all 0.2s",
//                           fontSize: "14px",
//                           color: "white",
//                           backgroundColor:
//                             viewingCert && viewingCert.certId === cert.certId
//                               ? "#c2410c"
//                               : "#ea580c",
//                           border: "none",
//                           cursor: "pointer",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.target.style.backgroundColor =
//                             viewingCert && viewingCert.certId === cert.certId
//                               ? "#9a3412"
//                               : "#c2410c";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.backgroundColor =
//                             viewingCert && viewingCert.certId === cert.certId
//                               ? "#c2410c"
//                               : "#ea580c";
//                         }}
//                         onClick={() => handleView(cert)}
//                       >
//                         {viewingCert && viewingCert.certId === cert.certId
//                           ? "Hide"
//                           : "View"}
//                       </button>
//                       <button
//                         style={{
//                           width: "100%",
//                           fontWeight: "500",
//                           padding: "10px 12px",
//                           borderRadius: "6px",
//                           transition: "all 0.2s",
//                           fontSize: "14px",
//                           color: "white",
//                           backgroundColor:
//                             detailsCert && detailsCert.certId === cert.certId
//                               ? "#c2410c"
//                               : "#ea580c",
//                           border: "none",
//                           cursor: "pointer",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.target.style.backgroundColor =
//                             detailsCert && detailsCert.certId === cert.certId
//                               ? "#9a3412"
//                               : "#c2410c";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.backgroundColor =
//                             detailsCert && detailsCert.certId === cert.certId
//                               ? "#c2410c"
//                               : "#ea580c";
//                         }}
//                         onClick={() => handleViewDetails(cert)}
//                       >
//                         {detailsCert && detailsCert.certId === cert.certId
//                           ? "Hide Details"
//                           : "View Details"}
//                       </button>
//                       <button
//                         style={{
//                           width: "100%",
//                           fontWeight: "500",
//                           padding: "10px 12px",
//                           borderRadius: "6px",
//                           transition: "all 0.2s",
//                           fontSize: "14px",
//                           color: "white",
//                           backgroundColor: "#f97316",
//                           border: "none",
//                           cursor: "pointer",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.target.style.backgroundColor = "#ea580c";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.backgroundColor = "#f97316";
//                         }}
//                         onClick={() => onEdit(cert)}
//                       >
//                         Edit
//                       </button>
//                       <button
//                         style={{
//                           width: "100%",
//                           fontWeight: "500",
//                           padding: "10px 12px",
//                           borderRadius: "6px",
//                           transition: "all 0.2s",
//                           fontSize: "14px",
//                           color: "white",
//                           backgroundColor: "#dc2626",
//                           border: "none",
//                           cursor:
//                             deletingId === cert.certId
//                               ? "not-allowed"
//                               : "pointer",
//                           opacity: deletingId === cert.certId ? 0.5 : 1,
//                         }}
//                         onMouseEnter={(e) => {
//                           if (deletingId !== cert.certId) {
//                             e.target.style.backgroundColor = "#b91c1c";
//                           }
//                         }}
//                         onMouseLeave={(e) => {
//                           if (deletingId !== cert.certId) {
//                             e.target.style.backgroundColor = "#dc2626";
//                           }
//                         }}
//                         onClick={() => handleDelete(cert.certId)}
//                         disabled={deletingId === cert.certId}
//                       >
//                         {deletingId === cert.certId ? "..." : "Delete"}
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Desktop Table View */}
//               <div className="hidden md:block overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Cert No.
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Student Name
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Branch
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Course
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Awarded On
//                       </th>
//                       <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Actions
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {filteredCertificates.map((cert) => (
//                       <tr
//                         key={cert.certId}
//                         className="hover:bg-gray-50 transition-colors"
//                       >
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                           {cert.certNo}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                           {cert.studentName}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                           {cert.branch}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                           {cert.course}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                           {cert.awardedOn}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-center">
//                           <div className="flex flex-wrap gap-2 justify-center">
//                             <button
//                               className={`px-4 py-2 rounded-md transition-colors text-sm text-white font-medium whitespace-nowrap ${
//                                 viewingCert &&
//                                 viewingCert.certId === cert.certId
//                                   ? "bg-orange-700 hover:bg-orange-800"
//                                   : "bg-orange-500 hover:bg-orange-600"
//                               }`}
//                               onClick={() => handleView(cert)}
//                             >
//                               {viewingCert && viewingCert.certId === cert.certId
//                                 ? "Hide"
//                                 : "View"}
//                             </button>
//                             <button
//                               className={`px-4 py-2 rounded-md transition-colors text-sm text-white font-medium whitespace-nowrap ${
//                                 detailsCert &&
//                                 detailsCert.certId === cert.certId
//                                   ? "bg-orange-700 hover:bg-orange-800"
//                                   : "bg-orange-500 hover:bg-orange-600"
//                               }`}
//                               onClick={() => handleViewDetails(cert)}
//                             >
//                               {detailsCert && detailsCert.certId === cert.certId
//                                 ? "Hide Details"
//                                 : "View Details"}
//                             </button>
//                             <button
//                               className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-md transition-colors text-sm whitespace-nowrap"
//                               onClick={() => onEdit(cert)}
//                             >
//                               Edit
//                             </button>
//                             <button
//                               className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors text-sm whitespace-nowrap disabled:opacity-50"
//                               onClick={() => handleDelete(cert.certId)}
//                               disabled={deletingId === cert.certId}
//                             >
//                               {deletingId === cert.certId ? "..." : "Delete"}
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CertificateList;












// ////
// import React, { useEffect, useState } from "react";

// const StudentDetailsPanel = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Date of Birth", cert.dob],
//     ["Email ID", cert.email],
//     ["Mobile No.", cert.mobile],
//     ["Contact Address", cert.address],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   return (
//     // <div className="mb-6 bg-emerald-50 border border-emerald-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
//     //   <div className="flex flex-wrap gap-2 justify-between items-center px-4 sm:px-6 py-4 border-b border-emerald-200 bg-emerald-100">
//     //     <h4 className="text-base sm:text-lg font-semibold text-gray-800 break-words">
//     //       Student Details — {cert.studentName}
//     //     </h4>
//     //     <button
//     //       className="text-gray-500 hover:text-gray-800 text-sm font-medium bg-white/60 hover:bg-white px-3 py-1 rounded-md transition-colors shrink-0"
//     //       onClick={onClose}
//     //     >
//     //       Close ✕
//     //     </button>
//     //   </div>

//     //   <div className="px-4 sm:px-6 py-5 flex flex-col md:flex-row gap-6">
//     //     <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4 flex-1">
//     //       {rows.map(([label, value]) => (
//     //         <div
//     //           key={label}
//     //           className="flex flex-wrap justify-between items-center gap-x-4 gap-y-1 border-b border-emerald-100 pb-2"
//     //         >
//     //           <span className="text-md font-bold  text-gray-800">{label}: </span>
//     //           <span className="text-md text-gray-800 text-right ml-auto break-words max-w-[70%]">
//     //             {value || "—"}
//     //           </span>
//     //         </div>
//     //       ))}
//     //     </div>

//     //     {cert.studentImage && (
//     //       <div className="shrink-0 flex md:justify-end justify-center">
//     //         <img
//     //           src={`/${cert.studentImage}`}
//     //           alt={cert.studentName}
//     //           className="w-40 h-40 object-cover rounded-lg border border-emerald-200 shadow-sm"
//     //         />
//     //       </div>
//     //     )}
//     //   </div>
//     // </div>
//     <div className="mb-6 bg-emerald-50 border border-emerald-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
//       <div className="flex flex-wrap gap-2 justify-between items-center px-4 sm:px-6 py-4 border-b border-emerald-200 bg-emerald-100">
//         <h4 className="text-base sm:text-lg font-semibold text-gray-800 break-words">
//           Student Details — {cert.studentName}
//         </h4>
//         <button
//           className="text-gray-500 hover:text-gray-800 text-sm font-medium bg-white/60 hover:bg-white px-3 py-1 rounded-md transition-colors shrink-0"
//           onClick={onClose}
//         >
//           Close ✕
//         </button>
//       </div>

//       <div className="relative px-4 sm:px-6 py-5">
//         {cert.studentImage && (
//           <img
//             src={`/${cert.studentImage}`}
//             alt={cert.studentName}
//             style={{
//               position: "absolute",
//               top: "20px",
//               right: "24px",
//               width: "120px",
//               height: "120px",
//               objectFit: "cover",
//               maxWidth: "120px",
//               maxHeight: "120px",
//               zIndex: 10,
//             }}
//             className="rounded-lg border border-emerald-200 shadow-sm"
//           />
//         )}
//         <div
//           className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4"
//           style={cert.studentImage ? { paddingRight: "140px" } : undefined}
//         >
//           {rows.map(([label, value]) => (
//             <div
//               key={label}
//               className="flex flex-wrap justify-between items-center gap-x-4 gap-y-1 border-b border-emerald-100 pb-2"
//             >
//               <span className="text-md font-bold  text-gray-800">{label}: </span>
//               <span className="text-md text-gray-800 text-right ml-auto break-words max-w-[70%]">
//                 {value || "—"}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// const CertificateViewPanel = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   return (
//     <div className="mb-6 bg-orange-50 border border-orange-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
//       <div className="flex flex-wrap gap-2 justify-between items-center px-4 sm:px-6 py-4 border-b border-orange-200 bg-orange-100">
//         <h4 className="text-base sm:text-lg font-semibold text-gray-800 break-words">
//           Certificate — {cert.studentName}
//         </h4>
//         <button
//           className="text-gray-500 hover:text-gray-800 text-sm font-medium bg-white/60 hover:bg-white px-3 py-1 rounded-md transition-colors shrink-0"
//           onClick={onClose}
//         >
//           Close ✕
//         </button>
//       </div>

//       <div className="px-4 sm:px-6 py-6 flex justify-center">
//         <div className="w-full max-w-2xl bg-white border-4 border-double border-orange-300 rounded-lg p-6 sm:p-10 text-center">
//           <p className="text-xs sm:text-sm uppercase tracking-widest text-gray-500 mb-2">
//             Certificate of Completion
//           </p>
//           <p className="text-xl sm:text-2xl font-bold text-gray-800 mb-1">
//             {cert.studentName || "—"}
//           </p>
//           <p className="text-sm text-gray-500 mb-6">
//             Cert No. {cert.certNo || "—"}
//           </p>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-left mt-4">
//             {rows.map(([label, value]) => (
//               <div
//                 key={label}
//                 className="flex justify-between border-b border-gray-100 pb-2"
//               >
//                 <span className="text-xs sm:text-sm font-medium text-gray-500">
//                   {label}
//                 </span>
//                 <span className="text-xs sm:text-sm text-gray-800 text-right ml-4 break-words">
//                   {value || "—"}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div className="px-4 sm:px-6 pb-5 flex justify-center">
//         <button
//           className="bg-orange-500 hover:bg-orange-600 text-white font-medium py-2 px-5 rounded-md transition-colors text-sm"
//           onClick={onClose}
//         >
//           ← Back to list
//         </button>
//       </div>
//     </div>
//   );
// };

// const CertificateList = ({ onSelect, onEdit }) => {
//   const [certificates, setCertificates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deletingId, setDeletingId] = useState(null);
//   const [detailsCert, setDetailsCert] = useState(null);
//   const [viewingCert, setViewingCert] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await fetch("/api/certificates");
//         if (!res.ok) throw new Error("Failed to load certificates");
//         const data = await res.json();
//         setCertificates(data);
//       } catch (err) {
//         setError(err.message || "Something went wrong.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   const handleDelete = async (certId) => {
//     if (!window.confirm("Delete this certificate? This cannot be undone."))
//       return;
//     setDeletingId(certId);
//     try {
//       const res = await fetch(
//         `/api/certificates/${certId}`,
//         { method: "DELETE" },
//       );
//       if (!res.ok) throw new Error("Failed to delete certificate");
//       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
//       if (detailsCert && detailsCert.certId === certId) setDetailsCert(null);
//       if (viewingCert && viewingCert.certId === certId) setViewingCert(null);
//     } catch (err) {
//       setError(err.message || "Failed to delete certificate.");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   const handleViewDetails = (cert) => {
//     setDetailsCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//   };

//   const handleView = (cert) => {
//     setViewingCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//     if (typeof onSelect === "function") onSelect(cert);
//   };

//   const filteredCertificates = certificates.filter((cert) => {
//     const term = searchTerm.trim().toLowerCase();
//     if (!term) return true;
//     return Object.values(cert || {}).some((val) => {
//       if (val === null || val === undefined) return false;
//       if (typeof val === "string" || typeof val === "number") {
//         return String(val).toLowerCase().includes(term);
//       }
//       return false;
//     });
//   });

//   if (loading)
//     return (
//       <div className="card ctm-border-radius shadow-sm">
//         <div className="card-body">Loading...</div>
//       </div>
//     );
//   if (error) return <div className="alert alert-danger">{error}</div>;

//   return (
//     <div className="w-full px-4 py-6">
//       <div className="bg-white rounded-lg shadow-md overflow-hidden">
//         <div className="p-4 md:p-6">
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 md:mb-6">
//             <h4 className="text-gray-800 text-lg sm:text-xl font-semibold">
//               All Certificates
//             </h4>

//             <div className="relative w-full sm:w-64 md:w-80">
//               <span
//                 className="absolute inset-y-0 left-0 flex items-center justify-center pl-3 text-gray-400 pointer-events-none"
//                 style={{ width: "2rem" }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   style={{ width: "16px", height: "16px", flexShrink: 0 }}
//                 >
//                   <circle cx="11" cy="11" r="8" />
//                   <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                 </svg>
//               </span>
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search by name, cert no, branch, course..."
//                 className="w-full pl-9 pr-8 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
//               />
//               {searchTerm && (
//                 <button
//                   onClick={() => setSearchTerm("")}
//                   className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600 text-sm leading-none"
//                   aria-label="Clear search"
//                 >
//                   ✕
//                 </button>
//               )}
//             </div>
//           </div>

//           <CertificateViewPanel
//             cert={viewingCert}
//             onClose={() => setViewingCert(null)}
//           />

//           <StudentDetailsPanel
//             cert={detailsCert}
//             onClose={() => setDetailsCert(null)}
//           />

//           {certificates.length === 0 ? (
//             <p className="text-gray-500 text-center py-8">
//               No certificates generated yet.
//             </p>
//           ) : filteredCertificates.length === 0 ? (
//             <p className="text-gray-500 text-center py-8">
//               No certificates match your search.
//             </p>
//           ) : (
//             <>
//               {/* Mobile Card View */}
//               <div className="md:hidden space-y-4">
//                 {filteredCertificates.map((cert) => (
//                   <div
//                     key={cert.certId}
//                     className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:shadow-md transition-shadow"
//                   >
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-bold text-gray-700">
//                         Cert No. :
//                       </span>
//                       <span className="text-sm font-semibold text-gray-900">
//                         {cert.certNo}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-bold text-gray-700">
//                         Student Name :
//                       </span>
//                       <span className="text-sm font-semibold text-gray-900">
//                         {cert.studentName}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-bold text-gray-700">
//                         Branch :
//                       </span>
//                       <span className="text-sm text-gray-700">
//                         {cert.branch}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-start mb-2">
//                       <span className="text-sm font-bold text-gray-700">
//                         Course :
//                       </span>
//                       <span className="text-sm text-gray-700">
//                         {cert.course}
//                       </span>
//                     </div>
//                     <div className="flex justify-between items-start mb-3">
//                       <span className="text-sm font-bold text-gray-700">
//                         Awarded On :
//                       </span>
//                       <span className="text-sm text-gray-700">
//                         {cert.awardedOn}
//                       </span>
//                     </div>
//                     <div
//                       style={{
//                         display: "grid",
//                         gridTemplateColumns: "1fr 1fr",
//                         gap: "8px",
//                       }}
//                     >
//                       <button
//                         style={{
//                           width: "100%",
//                           fontWeight: "500",
//                           padding: "10px 12px",
//                           borderRadius: "6px",
//                           transition: "all 0.2s",
//                           fontSize: "14px",
//                           color: "white",
//                           backgroundColor:
//                             viewingCert && viewingCert.certId === cert.certId
//                               ? "#c2410c"
//                               : "#ea580c",
//                           border: "none",
//                           cursor: "pointer",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.target.style.backgroundColor =
//                             viewingCert && viewingCert.certId === cert.certId
//                               ? "#9a3412"
//                               : "#c2410c";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.backgroundColor =
//                             viewingCert && viewingCert.certId === cert.certId
//                               ? "#c2410c"
//                               : "#ea580c";
//                         }}
//                         onClick={() => handleView(cert)}
//                       >
//                         {viewingCert && viewingCert.certId === cert.certId
//                           ? "Hide"
//                           : "View"}
//                       </button>
//                       <button
//                         style={{
//                           width: "100%",
//                           fontWeight: "500",
//                           padding: "10px 12px",
//                           borderRadius: "6px",
//                           transition: "all 0.2s",
//                           fontSize: "14px",
//                           color: "white",
//                           backgroundColor:
//                             detailsCert && detailsCert.certId === cert.certId
//                               ? "#c2410c"
//                               : "#ea580c",
//                           border: "none",
//                           cursor: "pointer",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.target.style.backgroundColor =
//                             detailsCert && detailsCert.certId === cert.certId
//                               ? "#9a3412"
//                               : "#c2410c";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.backgroundColor =
//                             detailsCert && detailsCert.certId === cert.certId
//                               ? "#c2410c"
//                               : "#ea580c";
//                         }}
//                         onClick={() => handleViewDetails(cert)}
//                       >
//                         {detailsCert && detailsCert.certId === cert.certId
//                           ? "Hide Details"
//                           : "View Details"}
//                       </button>
//                       <button
//                         style={{
//                           width: "100%",
//                           fontWeight: "500",
//                           padding: "10px 12px",
//                           borderRadius: "6px",
//                           transition: "all 0.2s",
//                           fontSize: "14px",
//                           color: "white",
//                           backgroundColor: "#f97316",
//                           border: "none",
//                           cursor: "pointer",
//                         }}
//                         onMouseEnter={(e) => {
//                           e.target.style.backgroundColor = "#ea580c";
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.backgroundColor = "#f97316";
//                         }}
//                         onClick={() => onEdit(cert)}
//                       >
//                         Edit
//                       </button>
//                       <button
//                         style={{
//                           width: "100%",
//                           fontWeight: "500",
//                           padding: "10px 12px",
//                           borderRadius: "6px",
//                           transition: "all 0.2s",
//                           fontSize: "14px",
//                           color: "white",
//                           backgroundColor: "#dc2626",
//                           border: "none",
//                           cursor:
//                             deletingId === cert.certId
//                               ? "not-allowed"
//                               : "pointer",
//                           opacity: deletingId === cert.certId ? 0.5 : 1,
//                         }}
//                         onMouseEnter={(e) => {
//                           if (deletingId !== cert.certId) {
//                             e.target.style.backgroundColor = "#b91c1c";
//                           }
//                         }}
//                         onMouseLeave={(e) => {
//                           if (deletingId !== cert.certId) {
//                             e.target.style.backgroundColor = "#dc2626";
//                           }
//                         }}
//                         onClick={() => handleDelete(cert.certId)}
//                         disabled={deletingId === cert.certId}
//                       >
//                         {deletingId === cert.certId ? "..." : "Delete"}
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Desktop Table View */}
//               <div className="hidden md:block overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Cert No.
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Student Name
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Branch
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Course
//                       </th>
//                       <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Awarded On
//                       </th>
//                       <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Actions
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {filteredCertificates.map((cert) => (
//                       <tr
//                         key={cert.certId}
//                         className="hover:bg-gray-50 transition-colors"
//                       >
//                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                           {cert.certNo}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                           {cert.studentName}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                           {cert.branch}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                           {cert.course}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
//                           {cert.awardedOn}
//                         </td>
//                         <td className="px-6 py-4 whitespace-nowrap text-center">
//                           <div className="flex flex-wrap gap-2 justify-center">
//                             <button
//                               className={`px-4 py-2 rounded-md transition-colors text-sm text-white font-medium whitespace-nowrap ${
//                                 viewingCert &&
//                                 viewingCert.certId === cert.certId
//                                   ? "bg-orange-700 hover:bg-orange-800"
//                                   : "bg-orange-500 hover:bg-orange-600"
//                               }`}
//                               onClick={() => handleView(cert)}
//                             >
//                               {viewingCert && viewingCert.certId === cert.certId
//                                 ? "Hide"
//                                 : "View"}
//                             </button>
//                             <button
//                               className={`px-4 py-2 rounded-md transition-colors text-sm text-white font-medium whitespace-nowrap ${
//                                 detailsCert &&
//                                 detailsCert.certId === cert.certId
//                                   ? "bg-orange-700 hover:bg-orange-800"
//                                   : "bg-orange-500 hover:bg-orange-600"
//                               }`}
//                               onClick={() => handleViewDetails(cert)}
//                             >
//                               {detailsCert && detailsCert.certId === cert.certId
//                                 ? "Hide Details"
//                                 : "View Details"}
//                             </button>
//                             <button
//                               className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-md transition-colors text-sm whitespace-nowrap"
//                               onClick={() => onEdit(cert)}
//                             >
//                               Edit
//                             </button>
//                             <button
//                               className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors text-sm whitespace-nowrap disabled:opacity-50"
//                               onClick={() => handleDelete(cert.certId)}
//                               disabled={deletingId === cert.certId}
//                             >
//                               {deletingId === cert.certId ? "..." : "Delete"}
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CertificateList;


// import React, { useEffect, useState } from "react";

// const StudentDetailsModal = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Date of Birth", cert.dob],
//     ["Email ID", cert.email],
//     ["Mobile No.", cert.mobile],
//     ["Contact Address", cert.address],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   const overlayStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1000,
//     padding: "16px",
//   };

//   const modalStyle = {
//     backgroundColor: "#ecfdf5",
//     border: "1px solid #a7f3d0",
//     borderRadius: "12px",
//     boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
//     overflow: "hidden",
//     width: "100%",
//     maxWidth: "640px",
//     maxHeight: "85vh",
//     display: "flex",
//     flexDirection: "column",
//   };

//   const headerStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "8px",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "16px 24px",
//     borderBottom: "1px solid #a7f3d0",
//     backgroundColor: "#d1fae5",
//   };

//   const titleStyle = {
//     fontSize: "18px",
//     fontWeight: 600,
//     color: "#1f2937",
//     wordBreak: "break-word",
//     margin: 0,
//   };

//   const closeBtnStyle = {
//     color: "#6b7280",
//     fontSize: "14px",
//     fontWeight: 500,
//     backgroundColor: "rgba(255,255,255,0.6)",
//     border: "none",
//     padding: "6px 12px",
//     borderRadius: "6px",
//     cursor: "pointer",
//     flexShrink: 0,
//   };

//   const bodyStyle = {
//     position: "relative",
//     padding: "20px 24px",
//     overflowY: "auto",
//   };

//   const imgStyle = {
//     position: "absolute",
//     top: "20px",
//     right: "24px",
//     width: "120px",
//     height: "120px",
//     objectFit: "cover",
//     maxWidth: "120px",
//     maxHeight: "120px",
//     zIndex: 10,
//     borderRadius: "8px",
//     border: "1px solid #a7f3d0",
//     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//   };

//   const gridStyle = {
//     display: "grid",
//     gridTemplateColumns: "1fr",
//     gap: "16px 40px",
//     paddingRight: cert.studentImage ? "140px" : undefined,
//   };

//   const rowStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "space-between",
//     alignItems: "center",
//     gap: "16px 4px",
//     borderBottom: "1px solid #d1fae5",
//     paddingBottom: "8px",
//   };

//   const labelStyle = {
//     fontSize: "16px",
//     fontWeight: 700,
//     color: "#1f2937",
//   };

//   const valueStyle = {
//     fontSize: "16px",
//     color: "#1f2937",
//     textAlign: "right",
//     marginLeft: "auto",
//     wordBreak: "break-word",
//     maxWidth: "70%",
//   };

//   return (
//     <div style={overlayStyle} onClick={onClose}>
//       <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
//         <div style={headerStyle}>
//           <h4 style={titleStyle}>Student Details — {cert.studentName}</h4>
//           <button style={closeBtnStyle} onClick={onClose}>
//             Close ✕
//           </button>
//         </div>

//         <div style={bodyStyle}>
//           {cert.studentImage && (
//             <img
//               src={`/${cert.studentImage}`}
//               alt={cert.studentName}
//               style={imgStyle}
//             />
//           )}
//           <div style={gridStyle}>
//             {rows.map(([label, value]) => (
//               <div key={label} style={rowStyle}>
//                 <span style={labelStyle}>{label}: </span>
//                 <span style={valueStyle}>{value || "—"}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const CertificateViewPanel = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   return (
//     <div
//       style={{
//         marginBottom: "24px",
//         backgroundColor: "#fff7ed",
//         border: "1px solid #fed7aa",
//         borderRadius: "12px",
//         boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
//         overflow: "hidden",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           gap: "8px",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "16px 24px",
//           borderBottom: "1px solid #fed7aa",
//           backgroundColor: "#ffedd5",
//         }}
//       >
//         <h4
//           style={{
//             fontSize: "18px",
//             fontWeight: 600,
//             color: "#1f2937",
//             wordBreak: "break-word",
//             margin: 0,
//           }}
//         >
//           Certificate — {cert.studentName}
//         </h4>
//         <button
//           style={{
//             color: "#6b7280",
//             fontSize: "14px",
//             fontWeight: 500,
//             backgroundColor: "rgba(255,255,255,0.6)",
//             border: "none",
//             padding: "6px 12px",
//             borderRadius: "6px",
//             cursor: "pointer",
//             flexShrink: 0,
//           }}
//           onClick={onClose}
//         >
//           Close ✕
//         </button>
//       </div>

//       <div
//         style={{
//           padding: "24px",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <div
//           style={{
//             width: "100%",
//             maxWidth: "640px",
//             backgroundColor: "#ffffff",
//             border: "4px double #fdba74",
//             borderRadius: "8px",
//             padding: "24px",
//             textAlign: "center",
//           }}
//         >
//           <p
//             style={{
//               fontSize: "13px",
//               textTransform: "uppercase",
//               letterSpacing: "2px",
//               color: "#6b7280",
//               marginBottom: "8px",
//             }}
//           >
//             Certificate of Completion
//           </p>
//           <p
//             style={{
//               fontSize: "22px",
//               fontWeight: 700,
//               color: "#1f2937",
//               marginBottom: "4px",
//             }}
//           >
//             {cert.studentName || "—"}
//           </p>
//           <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "24px" }}>
//             Cert No. {cert.certNo || "—"}
//           </p>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "12px 32px",
//               textAlign: "left",
//               marginTop: "16px",
//             }}
//           >
//             {rows.map(([label, value]) => (
//               <div
//                 key={label}
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   borderBottom: "1px solid #f3f4f6",
//                   paddingBottom: "8px",
//                 }}
//               >
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     fontWeight: 500,
//                     color: "#6b7280",
//                   }}
//                 >
//                   {label}
//                 </span>
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     color: "#1f2937",
//                     textAlign: "right",
//                     marginLeft: "16px",
//                     wordBreak: "break-word",
//                   }}
//                 >
//                   {value || "—"}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           padding: "0 24px 20px",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <button
//           style={{
//             backgroundColor: "#f97316",
//             color: "#ffffff",
//             fontWeight: 500,
//             padding: "8px 20px",
//             borderRadius: "6px",
//             border: "none",
//             cursor: "pointer",
//             fontSize: "14px",
//           }}
//           onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
//           onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
//           onClick={onClose}
//         >
//           ← Back to list
//         </button>
//       </div>
//     </div>
//   );
// };

// const CertificateList = ({ onSelect, onEdit }) => {
//   const [certificates, setCertificates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deletingId, setDeletingId] = useState(null);
//   const [detailsCert, setDetailsCert] = useState(null);
//   const [viewingCert, setViewingCert] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" ? window.innerWidth < 768 : false,
//   );

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await fetch("/api/certificates");
//         if (!res.ok) throw new Error("Failed to load certificates");
//         const data = await res.json();
//         setCertificates(data);
//       } catch (err) {
//         setError(err.message || "Something went wrong.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   const handleDelete = async (certId) => {
//     if (!window.confirm("Delete this certificate? This cannot be undone."))
//       return;
//     setDeletingId(certId);
//     try {
//       const res = await fetch(
//         `/api/certificates/${certId}`,
//         { method: "DELETE" },
//       );
//       if (!res.ok) throw new Error("Failed to delete certificate");
//       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
//       if (detailsCert && detailsCert.certId === certId) setDetailsCert(null);
//       if (viewingCert && viewingCert.certId === certId) setViewingCert(null);
//     } catch (err) {
//       setError(err.message || "Failed to delete certificate.");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   const handleViewDetails = (cert) => {
//     setDetailsCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//   };

//   const handleView = (cert) => {
//     setViewingCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//     if (typeof onSelect === "function") onSelect(cert);
//   };

//   const filteredCertificates = certificates.filter((cert) => {
//     const term = searchTerm.trim().toLowerCase();
//     if (!term) return true;
//     return Object.values(cert || {}).some((val) => {
//       if (val === null || val === undefined) return false;
//       if (typeof val === "string" || typeof val === "number") {
//         return String(val).toLowerCase().includes(term);
//       }
//       return false;
//     });
//   });

//   if (loading)
//     return (
//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           borderRadius: "8px",
//           boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
//         }}
//       >
//         <div style={{ padding: "16px" }}>Loading...</div>
//       </div>
//     );
//   if (error)
//     return (
//       <div
//         style={{
//           backgroundColor: "#f8d7da",
//           color: "#842029",
//           border: "1px solid #f5c2c7",
//           borderRadius: "6px",
//           padding: "12px 16px",
//         }}
//       >
//         {error}
//       </div>
//     );

//   const actionBtnBaseStyle = {
//     fontWeight: 500,
//     borderRadius: "6px",
//     transition: "all 0.2s",
//     fontSize: "14px",
//     color: "#ffffff",
//     border: "none",
//     cursor: "pointer",
//   };

//   return (
//     <div style={{ width: "100%", padding: "24px 16px" }}>
//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           borderRadius: "8px",
//           boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
//           overflow: "hidden",
//         }}
//       >
//         <div style={{ padding: "16px" }}>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               alignItems: isMobile ? "stretch" : "center",
//               justifyContent: "space-between",
//               gap: "12px",
//               marginBottom: "20px",
//             }}
//           >
//             <h4
//               style={{
//                 color: "#1f2937",
//                 fontSize: "20px",
//                 fontWeight: 600,
//                 margin: 0,
//               }}
//             >
//               All Certificates
//             </h4>

//             <div
//               style={{
//                 position: "relative",
//                 width: isMobile ? "100%" : "320px",
//               }}
//             >
//               <span
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   bottom: 0,
//                   left: 0,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   paddingLeft: "12px",
//                   color: "#9ca3af",
//                   pointerEvents: "none",
//                   width: "32px",
//                 }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   style={{ width: "16px", height: "16px", flexShrink: 0 }}
//                 >
//                   <circle cx="11" cy="11" r="8" />
//                   <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                 </svg>
//               </span>
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search by name, cert no, branch, course..."
//                 style={{
//                   width: "100%",
//                   paddingLeft: "36px",
//                   paddingRight: "32px",
//                   paddingTop: "8px",
//                   paddingBottom: "8px",
//                   fontSize: "14px",
//                   border: "1px solid #d1d5db",
//                   borderRadius: "6px",
//                   outline: "none",
//                   boxSizing: "border-box",
//                 }}
//               />
//               {searchTerm && (
//                 <button
//                   onClick={() => setSearchTerm("")}
//                   aria-label="Clear search"
//                   style={{
//                     position: "absolute",
//                     top: 0,
//                     bottom: 0,
//                     right: 0,
//                     display: "flex",
//                     alignItems: "center",
//                     paddingRight: "12px",
//                     color: "#9ca3af",
//                     fontSize: "14px",
//                     lineHeight: 1,
//                     background: "none",
//                     border: "none",
//                     cursor: "pointer",
//                   }}
//                 >
//                   ✕
//                 </button>
//               )}
//             </div>
//           </div>

//           <CertificateViewPanel
//             cert={viewingCert}
//             onClose={() => setViewingCert(null)}
//           />

//           <StudentDetailsModal
//             cert={detailsCert}
//             onClose={() => setDetailsCert(null)}
//           />

//           {certificates.length === 0 ? (
//             <p style={{ color: "#6b7280", textAlign: "center", padding: "32px 0" }}>
//               No certificates generated yet.
//             </p>
//           ) : filteredCertificates.length === 0 ? (
//             <p style={{ color: "#6b7280", textAlign: "center", padding: "32px 0" }}>
//               No certificates match your search.
//             </p>
//           ) : isMobile ? (
//             /* Mobile Card View */
//             <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//               {filteredCertificates.map((cert) => (
//                 <div
//                   key={cert.certId}
//                   style={{
//                     backgroundColor: "#f9fafb",
//                     borderRadius: "8px",
//                     padding: "16px",
//                     border: "1px solid #e5e7eb",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Cert No. :
//                     </span>
//                     <span style={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
//                       {cert.certNo}
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Student Name :
//                     </span>
//                     <span style={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
//                       {cert.studentName}
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Branch :
//                     </span>
//                     <span style={{ fontSize: "14px", color: "#374151" }}>{cert.branch}</span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Course :
//                     </span>
//                     <span style={{ fontSize: "14px", color: "#374151" }}>{cert.course}</span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "12px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Awarded On :
//                     </span>
//                     <span style={{ fontSize: "14px", color: "#374151" }}>{cert.awardedOn}</span>
//                   </div>
//                   <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns: "1fr 1fr",
//                       gap: "8px",
//                     }}
//                   >
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor:
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor =
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "#9a3412"
//                             : "#c2410c";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor =
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c";
//                       }}
//                       onClick={() => handleView(cert)}
//                     >
//                       {viewingCert && viewingCert.certId === cert.certId ? "Hide" : "View"}
//                     </button>
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor:
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor =
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "#9a3412"
//                             : "#c2410c";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor =
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c";
//                       }}
//                       onClick={() => handleViewDetails(cert)}
//                     >
//                       {detailsCert && detailsCert.certId === cert.certId
//                         ? "Hide Details"
//                         : "View Details"}
//                     </button>
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor: "#f97316",
//                       }}
//                       onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
//                       onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
//                       onClick={() => onEdit(cert)}
//                     >
//                       Edit
//                     </button>
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor: "#dc2626",
//                         cursor: deletingId === cert.certId ? "not-allowed" : "pointer",
//                         opacity: deletingId === cert.certId ? 0.5 : 1,
//                       }}
//                       onMouseEnter={(e) => {
//                         if (deletingId !== cert.certId) {
//                           e.target.style.backgroundColor = "#b91c1c";
//                         }
//                       }}
//                       onMouseLeave={(e) => {
//                         if (deletingId !== cert.certId) {
//                           e.target.style.backgroundColor = "#dc2626";
//                         }
//                       }}
//                       onClick={() => handleDelete(cert.certId)}
//                       disabled={deletingId === cert.certId}
//                     >
//                       {deletingId === cert.certId ? "..." : "Delete"}
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             /* Desktop Table View */
//             <div style={{ overflowX: "auto" }}>
//               <table style={{ minWidth: "100%", borderCollapse: "collapse" }}>
//                 <thead style={{ backgroundColor: "#f9fafb" }}>
//                   <tr>
//                     {["Cert No.", "Student Name", "Branch", "Course", "Awarded On"].map(
//                       (h) => (
//                         <th
//                           key={h}
//                           style={{
//                             padding: "12px 24px",
//                             textAlign: "left",
//                             fontSize: "12px",
//                             fontWeight: 500,
//                             color: "#6b7280",
//                             textTransform: "uppercase",
//                             letterSpacing: "0.05em",
//                             borderBottom: "1px solid #e5e7eb",
//                           }}
//                         >
//                           {h}
//                         </th>
//                       ),
//                     )}
//                     <th
//                       style={{
//                         padding: "12px 24px",
//                         textAlign: "center",
//                         fontSize: "12px",
//                         fontWeight: 500,
//                         color: "#6b7280",
//                         textTransform: "uppercase",
//                         letterSpacing: "0.05em",
//                         borderBottom: "1px solid #e5e7eb",
//                       }}
//                     >
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredCertificates.map((cert) => (
//                     <tr
//                       key={cert.certId}
//                       style={{ backgroundColor: "#ffffff", transition: "background-color 0.15s" }}
//                       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9fafb")}
//                       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffffff")}
//                     >
//                       <td
//                         style={{
//                           padding: "16px 24px",
//                           whiteSpace: "nowrap",
//                           fontSize: "14px",
//                           fontWeight: 500,
//                           color: "#111827",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.certNo}
//                       </td>
//                       <td
//                         style={{
//                           padding: "16px 24px",
//                           whiteSpace: "nowrap",
//                           fontSize: "14px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.studentName}
//                       </td>
//                       <td
//                         style={{
//                           padding: "16px 24px",
//                           whiteSpace: "nowrap",
//                           fontSize: "14px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.branch}
//                       </td>
//                       <td
//                         style={{
//                           padding: "16px 24px",
//                           whiteSpace: "nowrap",
//                           fontSize: "14px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.course}
//                       </td>
//                       <td
//                         style={{
//                           padding: "16px 24px",
//                           whiteSpace: "nowrap",
//                           fontSize: "14px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.awardedOn}
//                       </td>
//                       <td
//                         style={{
//                           padding: "16px 24px",
//                           whiteSpace: "nowrap",
//                           textAlign: "center",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             flexWrap: "wrap",
//                             gap: "8px",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "8px 16px",
//                               whiteSpace: "nowrap",
//                               backgroundColor:
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316",
//                             }}
//                             onMouseEnter={(e) => {
//                               e.target.style.backgroundColor =
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "#9a3412"
//                                   : "#ea580c";
//                             }}
//                             onMouseLeave={(e) => {
//                               e.target.style.backgroundColor =
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316";
//                             }}
//                             onClick={() => handleView(cert)}
//                           >
//                             {viewingCert && viewingCert.certId === cert.certId
//                               ? "Hide"
//                               : "View"}
//                           </button>
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "8px 16px",
//                               whiteSpace: "nowrap",
//                               backgroundColor:
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316",
//                             }}
//                             onMouseEnter={(e) => {
//                               e.target.style.backgroundColor =
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "#9a3412"
//                                   : "#ea580c";
//                             }}
//                             onMouseLeave={(e) => {
//                               e.target.style.backgroundColor =
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316";
//                             }}
//                             onClick={() => handleViewDetails(cert)}
//                           >
//                             {detailsCert && detailsCert.certId === cert.certId
//                               ? "Hide Details"
//                               : "View Details"}
//                           </button>
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "8px 16px",
//                               whiteSpace: "nowrap",
//                               backgroundColor: "#f97316",
//                             }}
//                             onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
//                             onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
//                             onClick={() => onEdit(cert)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "8px 16px",
//                               whiteSpace: "nowrap",
//                               backgroundColor: "#dc2626",
//                               cursor: deletingId === cert.certId ? "not-allowed" : "pointer",
//                               opacity: deletingId === cert.certId ? 0.5 : 1,
//                             }}
//                             onMouseEnter={(e) => {
//                               if (deletingId !== cert.certId) {
//                                 e.target.style.backgroundColor = "#b91c1c";
//                               }
//                             }}
//                             onMouseLeave={(e) => {
//                               if (deletingId !== cert.certId) {
//                                 e.target.style.backgroundColor = "#dc2626";
//                               }
//                             }}
//                             onClick={() => handleDelete(cert.certId)}
//                             disabled={deletingId === cert.certId}
//                           >
//                             {deletingId === cert.certId ? "..." : "Delete"}
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CertificateList;







// import React, { useEffect, useRef, useState } from "react";

// const StudentDetailsModal = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Date of Birth", cert.dob],
//     ["Email ID", cert.email],
//     ["Mobile No.", cert.mobile],
//     ["Contact Address", cert.address],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   const overlayStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1000,
//     padding: "16px",
//   };

//   const modalStyle = {
//     backgroundColor: "#ecfdf5",
//     border: "1px solid #a7f3d0",
//     borderRadius: "12px",
//     boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
//     overflow: "hidden",
//     width: "100%",
//     maxWidth: "640px",
//     maxHeight: "85vh",
//     display: "flex",
//     flexDirection: "column",
//   };

//   const headerStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "8px",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "16px 24px",
//     borderBottom: "1px solid #a7f3d0",
//     backgroundColor: "#d1fae5",
//   };

//   const titleStyle = {
//     fontSize: "18px",
//     fontWeight: 600,
//     color: "#1f2937",
//     wordBreak: "break-word",
//     margin: 0,
//   };

//   const closeBtnStyle = {
//     color: "#6b7280",
//     fontSize: "14px",
//     fontWeight: 500,
//     backgroundColor: "rgba(255,255,255,0.6)",
//     border: "none",
//     padding: "6px 12px",
//     borderRadius: "6px",
//     cursor: "pointer",
//     flexShrink: 0,
//   };

//   const bodyStyle = {
//     position: "relative",
//     padding: "20px 24px",
//     overflowY: "auto",
//   };

//   const imgStyle = {
//     position: "absolute",
//     top: "20px",
//     right: "24px",
//     width: "120px",
//     height: "120px",
//     objectFit: "cover",
//     maxWidth: "120px",
//     maxHeight: "120px",
//     zIndex: 10,
//     borderRadius: "8px",
//     border: "1px solid #a7f3d0",
//     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//   };

//   const gridStyle = {
//     display: "grid",
//     gridTemplateColumns: "1fr",
//     gap: "16px 40px",
//     paddingRight: cert.studentImage ? "140px" : undefined,
//   };

//   const rowStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "space-between",
//     alignItems: "center",
//     gap: "16px 4px",
//     borderBottom: "1px solid #d1fae5",
//     paddingBottom: "8px",
//   };

//   const labelStyle = {
//     fontSize: "16px",
//     fontWeight: 700,
//     color: "#1f2937",
//   };

//   const valueStyle = {
//     fontSize: "16px",
//     color: "#1f2937",
//     textAlign: "right",
//     marginLeft: "auto",
//     wordBreak: "break-word",
//     maxWidth: "70%",
//   };

//   return (
//     <div style={overlayStyle} onClick={onClose}>
//       <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
//         <div style={headerStyle}>
//           <h4 style={titleStyle}>Student Details — {cert.studentName}</h4>
//           <button style={closeBtnStyle} onClick={onClose}>
//             Close ✕
//           </button>
//         </div>

//         <div style={bodyStyle}>
//           {cert.studentImage && (
//             <img
//               src={`/${cert.studentImage}`}
//               alt={cert.studentName}
//               style={imgStyle}
//             />
//           )}
//           <div style={gridStyle}>
//             {rows.map(([label, value]) => (
//               <div key={label} style={rowStyle}>
//                 <span style={labelStyle}>{label}: </span>
//                 <span style={valueStyle}>{value || "—"}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const CertificateViewPanel = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   return (
//     <div
//       style={{
//         marginBottom: "24px",
//         backgroundColor: "#fff7ed",
//         border: "1px solid #fed7aa",
//         borderRadius: "12px",
//         boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
//         overflow: "hidden",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           gap: "8px",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "16px 24px",
//           borderBottom: "1px solid #fed7aa",
//           backgroundColor: "#ffedd5",
//         }}
//       >
//         <h4
//           style={{
//             fontSize: "18px",
//             fontWeight: 600,
//             color: "#1f2937",
//             wordBreak: "break-word",
//             margin: 0,
//           }}
//         >
//           Certificate — {cert.studentName}
//         </h4>
//         <button
//           style={{
//             color: "#6b7280",
//             fontSize: "14px",
//             fontWeight: 500,
//             backgroundColor: "rgba(255,255,255,0.6)",
//             border: "none",
//             padding: "6px 12px",
//             borderRadius: "6px",
//             cursor: "pointer",
//             flexShrink: 0,
//           }}
//           onClick={onClose}
//         >
//           Close ✕
//         </button>
//       </div>

//       <div
//         style={{
//           padding: "24px",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <div
//           style={{
//             width: "100%",
//             maxWidth: "640px",
//             backgroundColor: "#ffffff",
//             border: "4px double #fdba74",
//             borderRadius: "8px",
//             padding: "24px",
//             textAlign: "center",
//           }}
//         >
//           <p
//             style={{
//               fontSize: "13px",
//               textTransform: "uppercase",
//               letterSpacing: "2px",
//               color: "#6b7280",
//               marginBottom: "8px",
//             }}
//           >
//             Certificate of Completion
//           </p>
//           <p
//             style={{
//               fontSize: "22px",
//               fontWeight: 700,
//               color: "#1f2937",
//               marginBottom: "4px",
//             }}
//           >
//             {cert.studentName || "—"}
//           </p>
//           <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "24px" }}>
//             Cert No. {cert.certNo || "—"}
//           </p>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "12px 32px",
//               textAlign: "left",
//               marginTop: "16px",
//             }}
//           >
//             {rows.map(([label, value]) => (
//               <div
//                 key={label}
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   borderBottom: "1px solid #f3f4f6",
//                   paddingBottom: "8px",
//                 }}
//               >
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     fontWeight: 500,
//                     color: "#6b7280",
//                   }}
//                 >
//                   {label}
//                 </span>
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     color: "#1f2937",
//                     textAlign: "right",
//                     marginLeft: "16px",
//                     wordBreak: "break-word",
//                   }}
//                 >
//                   {value || "—"}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           padding: "0 24px 20px",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <button
//           style={{
//             backgroundColor: "#f97316",
//             color: "#ffffff",
//             fontWeight: 500,
//             padding: "8px 20px",
//             borderRadius: "6px",
//             border: "none",
//             cursor: "pointer",
//             fontSize: "14px",
//           }}
//           onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
//           onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
//           onClick={onClose}
//         >
//           ← Back to list
//         </button>
//       </div>
//     </div>
//   );
// };

// const CertificateList = ({ onSelect, onEdit }) => {
//   const [certificates, setCertificates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deletingId, setDeletingId] = useState(null);
//   const [detailsCert, setDetailsCert] = useState(null);
//   const [viewingCert, setViewingCert] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isMobile, setIsMobile] = useState(false);
//   const containerRef = useRef(null);

//   useEffect(() => {
//     const el = containerRef.current;
//     if (!el) return;

//     const evaluateWidth = (width) => setIsMobile(width < 700);

//     if (typeof ResizeObserver !== "undefined") {
//       const observer = new ResizeObserver((entries) => {
//         for (const entry of entries) {
//           evaluateWidth(entry.contentRect.width);
//         }
//       });
//       observer.observe(el);
//       evaluateWidth(el.getBoundingClientRect().width);
//       return () => observer.disconnect();
//     }

//     // Fallback for environments without ResizeObserver
//     const handleResize = () => evaluateWidth(el.getBoundingClientRect().width);
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await fetch("/api/certificates");
//         if (!res.ok) throw new Error("Failed to load certificates");
//         const data = await res.json();
//         setCertificates(data);
//       } catch (err) {
//         setError(err.message || "Something went wrong.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   const handleDelete = async (certId) => {
//     if (!window.confirm("Delete this certificate? This cannot be undone."))
//       return;
//     setDeletingId(certId);
//     try {
//       const res = await fetch(
//         `/api/certificates/${certId}`,
//         { method: "DELETE" },
//       );
//       if (!res.ok) throw new Error("Failed to delete certificate");
//       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
//       if (detailsCert && detailsCert.certId === certId) setDetailsCert(null);
//       if (viewingCert && viewingCert.certId === certId) setViewingCert(null);
//     } catch (err) {
//       setError(err.message || "Failed to delete certificate.");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   const handleViewDetails = (cert) => {
//     setDetailsCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//   };

//   const handleView = (cert) => {
//     setViewingCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//     if (typeof onSelect === "function") onSelect(cert);
//   };

//   const filteredCertificates = certificates.filter((cert) => {
//     const term = searchTerm.trim().toLowerCase();
//     if (!term) return true;
//     return Object.values(cert || {}).some((val) => {
//       if (val === null || val === undefined) return false;
//       if (typeof val === "string" || typeof val === "number") {
//         return String(val).toLowerCase().includes(term);
//       }
//       return false;
//     });
//   });

//   if (loading)
//     return (
//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           borderRadius: "8px",
//           boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
//         }}
//       >
//         <div style={{ padding: "16px" }}>Loading...</div>
//       </div>
//     );
//   if (error)
//     return (
//       <div
//         style={{
//           backgroundColor: "#f8d7da",
//           color: "#842029",
//           border: "1px solid #f5c2c7",
//           borderRadius: "6px",
//           padding: "12px 16px",
//         }}
//       >
//         {error}
//       </div>
//     );

//   const actionBtnBaseStyle = {
//     fontWeight: 500,
//     borderRadius: "6px",
//     transition: "all 0.2s",
//     fontSize: "14px",
//     color: "#ffffff",
//     border: "none",
//     cursor: "pointer",
//   };

//   return (
//     <div
//       ref={containerRef}
//       style={{ width: "100%", maxWidth: "100%", padding: "12px 8px", boxSizing: "border-box" }}
//     >
//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           borderRadius: "8px",
//           boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
//           overflow: "hidden",
//           width: "100%",
//           maxWidth: "100%",
//           boxSizing: "border-box",
//         }}
//       >
//         <div style={{ padding: "10px", width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               alignItems: isMobile ? "stretch" : "center",
//               justifyContent: "space-between",
//               gap: "10px",
//               marginBottom: "12px",
//             }}
//           >
//             <h4
//               style={{
//                 color: "#1f2937",
//                 fontSize: "18px",
//                 fontWeight: 600,
//                 margin: 0,
//               }}
//             >
//               All Certificates
//             </h4>

//             <div
//               style={{
//                 position: "relative",
//                 width: isMobile ? "100%" : "320px",
//               }}
//             >
//               <span
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   bottom: 0,
//                   left: 0,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   paddingLeft: "12px",
//                   color: "#9ca3af",
//                   pointerEvents: "none",
//                   width: "32px",
//                 }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   style={{ width: "16px", height: "16px", flexShrink: 0 }}
//                 >
//                   <circle cx="11" cy="11" r="8" />
//                   <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                 </svg>
//               </span>
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search by name, cert no, branch, course..."
//                 style={{
//                   width: "100%",
//                   paddingLeft: "36px",
//                   paddingRight: "32px",
//                   paddingTop: "8px",
//                   paddingBottom: "8px",
//                   fontSize: "14px",
//                   border: "1px solid #d1d5db",
//                   borderRadius: "6px",
//                   outline: "none",
//                   boxSizing: "border-box",
//                 }}
//               />
//               {searchTerm && (
//                 <button
//                   onClick={() => setSearchTerm("")}
//                   aria-label="Clear search"
//                   style={{
//                     position: "absolute",
//                     top: 0,
//                     bottom: 0,
//                     right: 0,
//                     display: "flex",
//                     alignItems: "center",
//                     paddingRight: "12px",
//                     color: "#9ca3af",
//                     fontSize: "14px",
//                     lineHeight: 1,
//                     background: "none",
//                     border: "none",
//                     cursor: "pointer",
//                   }}
//                 >
//                   ✕
//                 </button>
//               )}
//             </div>
//           </div>

//           <CertificateViewPanel
//             cert={viewingCert}
//             onClose={() => setViewingCert(null)}
//           />

//           <StudentDetailsModal
//             cert={detailsCert}
//             onClose={() => setDetailsCert(null)}
//           />

//           {certificates.length === 0 ? (
//             <p style={{ color: "#6b7280", textAlign: "center", padding: "32px 0" }}>
//               No certificates generated yet.
//             </p>
//           ) : filteredCertificates.length === 0 ? (
//             <p style={{ color: "#6b7280", textAlign: "center", padding: "32px 0" }}>
//               No certificates match your search.
//             </p>
//           ) : isMobile ? (
//             /* Mobile Card View */
//             <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//               {filteredCertificates.map((cert) => (
//                 <div
//                   key={cert.certId}
//                   style={{
//                     backgroundColor: "#f9fafb",
//                     borderRadius: "8px",
//                     padding: "16px",
//                     border: "1px solid #e5e7eb",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Cert No. :
//                     </span>
//                     <span style={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
//                       {cert.certNo}
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Student Name :
//                     </span>
//                     <span style={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
//                       {cert.studentName}
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Branch :
//                     </span>
//                     <span style={{ fontSize: "14px", color: "#374151" }}>{cert.branch}</span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Course :
//                     </span>
//                     <span style={{ fontSize: "14px", color: "#374151" }}>{cert.course}</span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "12px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Awarded On :
//                     </span>
//                     <span style={{ fontSize: "14px", color: "#374151" }}>{cert.awardedOn}</span>
//                   </div>
//                   <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns: "1fr 1fr",
//                       gap: "8px",
//                     }}
//                   >
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor:
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor =
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "#9a3412"
//                             : "#c2410c";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor =
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c";
//                       }}
//                       onClick={() => handleView(cert)}
//                     >
//                       {viewingCert && viewingCert.certId === cert.certId ? "Hide" : "View"}
//                     </button>
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor:
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor =
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "#9a3412"
//                             : "#c2410c";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor =
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c";
//                       }}
//                       onClick={() => handleViewDetails(cert)}
//                     >
//                       {detailsCert && detailsCert.certId === cert.certId
//                         ? "Hide Details"
//                         : "View Details"}
//                     </button>
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor: "#f97316",
//                       }}
//                       onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
//                       onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
//                       onClick={() => onEdit(cert)}
//                     >
//                       Edit
//                     </button>
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor: "#dc2626",
//                         cursor: deletingId === cert.certId ? "not-allowed" : "pointer",
//                         opacity: deletingId === cert.certId ? 0.5 : 1,
//                       }}
//                       onMouseEnter={(e) => {
//                         if (deletingId !== cert.certId) {
//                           e.target.style.backgroundColor = "#b91c1c";
//                         }
//                       }}
//                       onMouseLeave={(e) => {
//                         if (deletingId !== cert.certId) {
//                           e.target.style.backgroundColor = "#dc2626";
//                         }
//                       }}
//                       onClick={() => handleDelete(cert.certId)}
//                       disabled={deletingId === cert.certId}
//                     >
//                       {deletingId === cert.certId ? "..." : "Delete"}
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             /* Desktop Table View */
//             <div style={{ width: "100%", maxWidth: "100%" }}>
//               <table
//                 style={{
//                   width: "100%",
//                   maxWidth: "100%",
//                   tableLayout: "fixed",
//                   borderCollapse: "collapse",
//                 }}
//               >
//                 <colgroup>
//                   <col style={{ width: "12%" }} />
//                   <col style={{ width: "18%" }} />
//                   <col style={{ width: "12%" }} />
//                   <col style={{ width: "14%" }} />
//                   <col style={{ width: "12%" }} />
//                   <col style={{ width: "32%" }} />
//                 </colgroup>
//                 <thead style={{ backgroundColor: "#f9fafb" }}>
//                   <tr>
//                     {["Cert No.", "Student Name", "Branch", "Course", "Awarded On"].map(
//                       (h) => (
//                         <th
//                           key={h}
//                           style={{
//                             padding: "8px 6px",
//                             textAlign: "left",
//                             fontSize: "11px",
//                             fontWeight: 600,
//                             color: "#6b7280",
//                             textTransform: "uppercase",
//                             letterSpacing: "0.03em",
//                             borderBottom: "1px solid #e5e7eb",
//                             wordBreak: "break-word",
//                           }}
//                         >
//                           {h}
//                         </th>
//                       ),
//                     )}
//                     <th
//                       style={{
//                         padding: "8px 6px",
//                         textAlign: "center",
//                         fontSize: "11px",
//                         fontWeight: 600,
//                         color: "#6b7280",
//                         textTransform: "uppercase",
//                         letterSpacing: "0.03em",
//                         borderBottom: "1px solid #e5e7eb",
//                       }}
//                     >
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredCertificates.map((cert) => (
//                     <tr
//                       key={cert.certId}
//                       style={{ backgroundColor: "#ffffff", transition: "background-color 0.15s" }}
//                       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9fafb")}
//                       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffffff")}
//                     >
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           fontWeight: 500,
//                           color: "#111827",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.certNo}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.studentName}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.branch}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.course}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.awardedOn}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           textAlign: "center",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             flexWrap: "wrap",
//                             gap: "4px",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "5px 8px",
//                               fontSize: "12px",
//                               backgroundColor:
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316",
//                             }}
//                             onMouseEnter={(e) => {
//                               e.target.style.backgroundColor =
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "#9a3412"
//                                   : "#ea580c";
//                             }}
//                             onMouseLeave={(e) => {
//                               e.target.style.backgroundColor =
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316";
//                             }}
//                             onClick={() => handleView(cert)}
//                           >
//                             {viewingCert && viewingCert.certId === cert.certId
//                               ? "Hide"
//                               : "View"}
//                           </button>
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "5px 8px",
//                               fontSize: "12px",
//                               backgroundColor:
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316",
//                             }}
//                             onMouseEnter={(e) => {
//                               e.target.style.backgroundColor =
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "#9a3412"
//                                   : "#ea580c";
//                             }}
//                             onMouseLeave={(e) => {
//                               e.target.style.backgroundColor =
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316";
//                             }}
//                             onClick={() => handleViewDetails(cert)}
//                           >
//                             {detailsCert && detailsCert.certId === cert.certId
//                               ? "Hide"
//                               : "Details"}
//                           </button>
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "5px 8px",
//                               fontSize: "12px",
//                               backgroundColor: "#f97316",
//                             }}
//                             onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
//                             onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
//                             onClick={() => onEdit(cert)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "5px 8px",
//                               fontSize: "12px",
//                               backgroundColor: "#dc2626",
//                               cursor: deletingId === cert.certId ? "not-allowed" : "pointer",
//                               opacity: deletingId === cert.certId ? 0.5 : 1,
//                             }}
//                             onMouseEnter={(e) => {
//                               if (deletingId !== cert.certId) {
//                                 e.target.style.backgroundColor = "#b91c1c";
//                               }
//                             }}
//                             onMouseLeave={(e) => {
//                               if (deletingId !== cert.certId) {
//                                 e.target.style.backgroundColor = "#dc2626";
//                               }
//                             }}
//                             onClick={() => handleDelete(cert.certId)}
//                             disabled={deletingId === cert.certId}
//                           >
//                             {deletingId === cert.certId ? "..." : "Delete"}
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CertificateList;














// ///////..
// import React, { useEffect, useRef, useState } from "react";

// const StudentDetailsModal = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Date of Birth", cert.dob],
//     ["Email ID", cert.email],
//     ["Mobile No.", cert.mobile],
//     ["Contact Address", cert.address],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   const overlayStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0, 0, 0, 0.5)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     zIndex: 1000,
//     padding: "16px",
//   };

//   const modalStyle = {
//     backgroundColor: "#ecfdf5",
//     border: "1px solid #a7f3d0",
//     borderRadius: "12px",
//     boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
//     overflow: "hidden",
//     width: "100%",
//     maxWidth: "640px",
//     maxHeight: "85vh",
//     display: "flex",
//     flexDirection: "column",
//   };

//   const headerStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "8px",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "16px 24px",
//     borderBottom: "1px solid #a7f3d0",
//     backgroundColor: "#d1fae5",
//   };

//   const titleStyle = {
//     fontSize: "18px",
//     fontWeight: 600,
//     color: "#1f2937",
//     wordBreak: "break-word",
//     margin: 0,
//   };

//   const closeBtnStyle = {
//     color: "#6b7280",
//     fontSize: "14px",
//     fontWeight: 500,
//     backgroundColor: "rgba(255,255,255,0.6)",
//     border: "none",
//     padding: "6px 12px",
//     borderRadius: "6px",
//     cursor: "pointer",
//     flexShrink: 0,
//   };

//   const bodyStyle = {
//     position: "relative",
//     padding: "20px 24px",
//     overflowY: "auto",
//   };

//   const imgStyle = {
//     position: "absolute",
//     top: "20px",
//     right: "24px",
//     width: "120px",
//     height: "120px",
//     objectFit: "cover",
//     maxWidth: "120px",
//     maxHeight: "120px",
//     zIndex: 10,
//     borderRadius: "8px",
//     border: "1px solid #a7f3d0",
//     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//   };

//   const gridStyle = {
//     display: "grid",
//     gridTemplateColumns: "1fr",
//     gap: "16px 40px",
//     paddingRight: cert.studentImage ? "140px" : undefined,
//   };

//   const rowStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "space-between",
//     alignItems: "center",
//     gap: "16px 4px",
//     borderBottom: "1px solid #d1fae5",
//     paddingBottom: "8px",
//   };

//   const labelStyle = {
//     fontSize: "16px",
//     fontWeight: 700,
//     color: "#1f2937",
//   };

//   const valueStyle = {
//     fontSize: "16px",
//     color: "#1f2937",
//     textAlign: "right",
//     marginLeft: "auto",
//     wordBreak: "break-word",
//     maxWidth: "70%",
//   };

//   return (
//     <div style={overlayStyle} onClick={onClose}>
//       <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
//         <div style={headerStyle}>
//           <h4 style={titleStyle}>Student Details — {cert.studentName}</h4>
//           <button style={closeBtnStyle} onClick={onClose}>
//             Close ✕
//           </button>
//         </div>

//         <div style={bodyStyle}>
//           {cert.studentImage && (
//             <img
//               src={`/${cert.studentImage}`}
//               alt={cert.studentName}
//               style={imgStyle}
//             />
//           )}
//           <div style={gridStyle}>
//             {rows.map(([label, value]) => (
//               <div key={label} style={rowStyle}>
//                 <span style={labelStyle}>{label}: </span>
//                 <span style={valueStyle}>{value || "—"}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const CertificateViewPanel = ({ cert, onClose }) => {
//   if (!cert) return null;

//   const rows = [
//     ["Certificate No.", cert.certNo],
//     ["Student Name", cert.studentName],
//     ["Father's Name", cert.fatherName],
//     ["Branch", cert.branch],
//     ["Course / Training", cert.course],
//     ["Training Centre", cert.centre],
//     ["College", cert.college],
//     ["Qualification", cert.qualification],
//     ["Start Date", cert.startDate],
//     ["End Date", cert.endDate],
//     ["Awarded On", cert.awardedOn],
//   ];

//   return (
//     <div
//       style={{
//         marginBottom: "24px",
//         backgroundColor: "#fff7ed",
//         border: "1px solid #fed7aa",
//         borderRadius: "12px",
//         boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
//         overflow: "hidden",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           gap: "8px",
//           justifyContent: "space-between",
//           alignItems: "center",
//           padding: "16px 24px",
//           borderBottom: "1px solid #fed7aa",
//           backgroundColor: "#ffedd5",
//         }}
//       >
//         <h4
//           style={{
//             fontSize: "18px",
//             fontWeight: 600,
//             color: "#1f2937",
//             wordBreak: "break-word",
//             margin: 0,
//           }}
//         >
//           Certificate — {cert.studentName}
//         </h4>
//         <button
//           style={{
//             color: "#6b7280",
//             fontSize: "14px",
//             fontWeight: 500,
//             backgroundColor: "rgba(255,255,255,0.6)",
//             border: "none",
//             padding: "6px 12px",
//             borderRadius: "6px",
//             cursor: "pointer",
//             flexShrink: 0,
//           }}
//           onClick={onClose}
//         >
//           Close ✕
//         </button>
//       </div>

//       <div
//         style={{
//           padding: "24px",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <div
//           style={{
//             width: "100%",
//             maxWidth: "640px",
//             backgroundColor: "#ffffff",
//             border: "4px double #fdba74",
//             borderRadius: "8px",
//             padding: "24px",
//             textAlign: "center",
//           }}
//         >
//           <p
//             style={{
//               fontSize: "13px",
//               textTransform: "uppercase",
//               letterSpacing: "2px",
//               color: "#6b7280",
//               marginBottom: "8px",
//             }}
//           >
//             Certificate of Completion
//           </p>
//           <p
//             style={{
//               fontSize: "22px",
//               fontWeight: 700,
//               color: "#1f2937",
//               marginBottom: "4px",
//             }}
//           >
//             {cert.studentName || "—"}
//           </p>
//           <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "24px" }}>
//             Cert No. {cert.certNo || "—"}
//           </p>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "12px 32px",
//               textAlign: "left",
//               marginTop: "16px",
//             }}
//           >
//             {rows.map(([label, value]) => (
//               <div
//                 key={label}
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   borderBottom: "1px solid #f3f4f6",
//                   paddingBottom: "8px",
//                 }}
//               >
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     fontWeight: 500,
//                     color: "#6b7280",
//                   }}
//                 >
//                   {label}
//                 </span>
//                 <span
//                   style={{
//                     fontSize: "13px",
//                     color: "#1f2937",
//                     textAlign: "right",
//                     marginLeft: "16px",
//                     wordBreak: "break-word",
//                   }}
//                 >
//                   {value || "—"}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           padding: "0 24px 20px",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <button
//           style={{
//             backgroundColor: "#f97316",
//             color: "#ffffff",
//             fontWeight: 500,
//             padding: "8px 20px",
//             borderRadius: "6px",
//             border: "none",
//             cursor: "pointer",
//             fontSize: "14px",
//           }}
//           onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
//           onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
//           onClick={onClose}
//         >
//           ← Back to list
//         </button>
//       </div>
//     </div>
//   );
// };

// const CertificateList = ({ onSelect, onEdit }) => {
//   const [certificates, setCertificates] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deletingId, setDeletingId] = useState(null);
//   const [detailsCert, setDetailsCert] = useState(null);
//   const [viewingCert, setViewingCert] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" ? window.innerWidth < 768 : false,
//   );
//   const containerRef = useRef(null);

//   useEffect(() => {
//     const evaluate = () => {
//       const windowWidth = typeof window !== "undefined" ? window.innerWidth : Infinity;
//       const containerWidth = containerRef.current
//         ? containerRef.current.getBoundingClientRect().width
//         : Infinity;
//       setIsMobile(windowWidth < 768 || containerWidth < 700);
//     };

//     evaluate();

//     window.addEventListener("resize", evaluate);

//     let observer;
//     if (typeof ResizeObserver !== "undefined" && containerRef.current) {
//       observer = new ResizeObserver(evaluate);
//       observer.observe(containerRef.current);
//     }

//     return () => {
//       window.removeEventListener("resize", evaluate);
//       if (observer) observer.disconnect();
//     };
//   }, []);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await fetch("/api/certificates");
//         if (!res.ok) throw new Error("Failed to load certificates");
//         const data = await res.json();
//         setCertificates(data);
//       } catch (err) {
//         setError(err.message || "Something went wrong.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, []);

//   const handleDelete = async (certId) => {
//     if (!window.confirm("Delete this certificate? This cannot be undone."))
//       return;
//     setDeletingId(certId);
//     try {
//       const res = await fetch(
//         `/api/certificates/${certId}`,
//         { method: "DELETE" },
//       );
//       if (!res.ok) throw new Error("Failed to delete certificate");
//       setCertificates((prev) => prev.filter((c) => c.certId !== certId));
//       if (detailsCert && detailsCert.certId === certId) setDetailsCert(null);
//       if (viewingCert && viewingCert.certId === certId) setViewingCert(null);
//     } catch (err) {
//       setError(err.message || "Failed to delete certificate.");
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   const handleViewDetails = (cert) => {
//     setDetailsCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//   };

//   const handleView = (cert) => {
//     setViewingCert((prev) =>
//       prev && prev.certId === cert.certId ? null : cert,
//     );
//     if (typeof onSelect === "function") onSelect(cert);
//   };

//   const filteredCertificates = certificates.filter((cert) => {
//     const term = searchTerm.trim().toLowerCase();
//     if (!term) return true;
//     return Object.values(cert || {}).some((val) => {
//       if (val === null || val === undefined) return false;
//       if (typeof val === "string" || typeof val === "number") {
//         return String(val).toLowerCase().includes(term);
//       }
//       return false;
//     });
//   });

//   if (loading)
//     return (
//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           borderRadius: "8px",
//           boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
//         }}
//       >
//         <div style={{ padding: "16px" }}>Loading...</div>
//       </div>
//     );
//   if (error)
//     return (
//       <div
//         style={{
//           backgroundColor: "#f8d7da",
//           color: "#842029",
//           border: "1px solid #f5c2c7",
//           borderRadius: "6px",
//           padding: "12px 16px",
//         }}
//       >
//         {error}
//       </div>
//     );

//   const actionBtnBaseStyle = {
//     fontWeight: 500,
//     borderRadius: "6px",
//     transition: "all 0.2s",
//     fontSize: "14px",
//     color: "#ffffff",
//     border: "none",
//     cursor: "pointer",
//   };

//   return (
//     <div
//       ref={containerRef}
//       style={{ width: "100%", maxWidth: "100%", padding: "12px 8px", boxSizing: "border-box" }}
//     >
//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           borderRadius: "8px",
//           boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
//           overflow: "hidden",
//           width: "100%",
//           maxWidth: "100%",
//           boxSizing: "border-box",
//         }}
//       >
//         <div style={{ padding: "10px", width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               alignItems: isMobile ? "stretch" : "center",
//               justifyContent: "space-between",
//               gap: "10px",
//               marginBottom: "12px",

//               whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",

//             }}
//           >
//             <h4
//               style={{
//                 color: "#1f2937",
//                 fontSize: "18px",
//                 fontWeight: 600,
//                 margin: 0,
//                 whiteSpace: "nowrap",
//                 overflow: "hidden",
//                 textOverflow: "ellipsis",
//               }}
//             >
//               All Certificates
//             </h4>

//             <div
//               style={{
//                 position: "relative",
//                 width: isMobile ? "100%" : "320px",
//               }}
//             >
//               <span
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   bottom: 0,
//                   left: 0,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   paddingLeft: "12px",
//                   color: "#9ca3af",
//                   pointerEvents: "none",
//                   width: "32px",
//                 }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   style={{ width: "16px", height: "16px", flexShrink: 0 }}
//                 >
//                   <circle cx="11" cy="11" r="8" />
//                   <line x1="21" y1="21" x2="16.65" y2="16.65" />
//                 </svg>
//               </span>
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search by name, cert no, branch, course..."
//                 style={{
//                   width: "100%",
//                   paddingLeft: "36px",
//                   paddingRight: "32px",
//                   paddingTop: "8px",
//                   paddingBottom: "8px",
//                   fontSize: "14px",
//                   border: "1px solid #d1d5db",
//                   borderRadius: "6px",
//                   outline: "none",
//                   boxSizing: "border-box",
//                 }}
//               />
//               {searchTerm && (
//                 <button
//                   onClick={() => setSearchTerm("")}
//                   aria-label="Clear search"
//                   style={{
//                     position: "absolute",
//                     top: 0,
//                     bottom: 0,
//                     right: 0,
//                     display: "flex",
//                     alignItems: "center",
//                     paddingRight: "12px",
//                     color: "#9ca3af",
//                     fontSize: "14px",
//                     lineHeight: 1,
//                     background: "none",
//                     border: "none",
//                     cursor: "pointer",
//                   }}
//                 >
//                   ✕
//                 </button>
//               )}
//             </div>
//           </div>

//           <CertificateViewPanel
//             cert={viewingCert}
//             onClose={() => setViewingCert(null)}
//           />

//           <StudentDetailsModal
//             cert={detailsCert}
//             onClose={() => setDetailsCert(null)}
//           />

//           {certificates.length === 0 ? (
//             <p style={{ color: "#6b7280", textAlign: "center", padding: "32px 0" }}>
//               No certificates generated yet.
//             </p>
//           ) : filteredCertificates.length === 0 ? (
//             <p style={{ color: "#6b7280", textAlign: "center", padding: "32px 0" }}>
//               No certificates match your search.
//             </p>
//           ) : isMobile ? (
//             /* Mobile Card View */
//             <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//               {filteredCertificates.map((cert) => (
//                 <div
//                   key={cert.certId}
//                   style={{
//                     backgroundColor: "#f9fafb",
//                     borderRadius: "8px",
//                     padding: "16px",
//                     border: "1px solid #e5e7eb",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Cert No. :
//                     </span>
//                     <span style={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
//                       {cert.certNo}
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Student Name :
//                     </span>
//                     <span style={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
//                       {cert.studentName}
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Branch :
//                     </span>
//                     <span style={{ fontSize: "14px", color: "#374151" }}>{cert.branch}</span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "8px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Course :
//                     </span>
//                     <span style={{ fontSize: "14px", color: "#374151" }}>{cert.course}</span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "flex-start",
//                       marginBottom: "12px",
//                     }}
//                   >
//                     <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
//                       Awarded On :
//                     </span>
//                     <span style={{ fontSize: "14px", color: "#374151" }}>{cert.awardedOn}</span>
//                   </div>
//                   <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns: "1fr 1fr",
//                       gap: "8px",
//                     }}
//                   >
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor:
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor =
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "#9a3412"
//                             : "#c2410c";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor =
//                           viewingCert && viewingCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c";
//                       }}
//                       onClick={() => handleView(cert)}
//                     >
//                       {viewingCert && viewingCert.certId === cert.certId ? "Hide" : "View"}
//                     </button>
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor:
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor =
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "#9a3412"
//                             : "#c2410c";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor =
//                           detailsCert && detailsCert.certId === cert.certId
//                             ? "#c2410c"
//                             : "#ea580c";
//                       }}
//                       onClick={() => handleViewDetails(cert)}
//                     >
//                       {detailsCert && detailsCert.certId === cert.certId
//                         ? "Hide Details"
//                         : "View Details"}
//                     </button>
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor: "#f97316",
//                       }}
//                       onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
//                       onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
//                       onClick={() => onEdit(cert)}
//                     >
//                       Edit
//                     </button>
//                     <button
//                       style={{
//                         ...actionBtnBaseStyle,
//                         width: "100%",
//                         padding: "10px 12px",
//                         backgroundColor: "#dc2626",
//                         cursor: deletingId === cert.certId ? "not-allowed" : "pointer",
//                         opacity: deletingId === cert.certId ? 0.5 : 1,
//                       }}
//                       onMouseEnter={(e) => {
//                         if (deletingId !== cert.certId) {
//                           e.target.style.backgroundColor = "#b91c1c";
//                         }
//                       }}
//                       onMouseLeave={(e) => {
//                         if (deletingId !== cert.certId) {
//                           e.target.style.backgroundColor = "#dc2626";
//                         }
//                       }}
//                       onClick={() => handleDelete(cert.certId)}
//                       disabled={deletingId === cert.certId}
//                     >
//                       {deletingId === cert.certId ? "..." : "Delete"}
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             /* Desktop Table View */
//             <div style={{ width: "100%", maxWidth: "100%" }}>
//               <table
//                 style={{
//                   width: "100%",
//                   maxWidth: "100%",
//                   tableLayout: "fixed",
//                   borderCollapse: "collapse",
//                 }}
//               >
//                 <colgroup>
//                   <col style={{ width: "12%" }} />
//                   <col style={{ width: "18%" }} />
//                   <col style={{ width: "12%" }} />
//                   <col style={{ width: "14%" }} />
//                   <col style={{ width: "12%" }} />
//                   <col style={{ width: "32%" }} />
//                 </colgroup>
//                 <thead style={{ backgroundColor: "#f9fafb" }}>
//                   <tr>
//                     {["Cert No.", "Student Name", "Branch", "Course", "Awarded On"].map(
//                       (h) => (
//                         <th
//                           key={h}
//                           style={{
//                             padding: "8px 6px",
//                             textAlign: "left",
//                             fontSize: "11px",
//                             fontWeight: 600,
//                             color: "#6b7280",
//                             textTransform: "uppercase",
//                             letterSpacing: "0.03em",
//                             borderBottom: "1px solid #e5e7eb",
//                             wordBreak: "break-word",
//                           }}
//                         >
//                           {h}
//                         </th>
//                       ),
//                     )}
//                     <th
//                       style={{
//                         padding: "8px 6px",
//                         textAlign: "center",
//                         fontSize: "11px",
//                         fontWeight: 600,
//                         color: "#6b7280",
//                         textTransform: "uppercase",
//                         letterSpacing: "0.03em",
//                         borderBottom: "1px solid #e5e7eb",
//                       }}
//                     >
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredCertificates.map((cert) => (
//                     <tr
//                       key={cert.certId}
//                       style={{ backgroundColor: "#ffffff", transition: "background-color 0.15s" }}
//                       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9fafb")}
//                       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffffff")}
//                     >
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           fontWeight: 500,
//                           color: "#111827",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.certNo}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.studentName}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.branch}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.course}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           wordBreak: "break-word",
//                           fontSize: "13px",
//                           color: "#374151",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         {cert.awardedOn}
//                       </td>
//                       <td
//                         style={{
//                           padding: "10px 6px",
//                           textAlign: "center",
//                           borderBottom: "1px solid #e5e7eb",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             flexWrap: "wrap",
//                             gap: "4px",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "5px 8px",
//                               fontSize: "12px",
//                               backgroundColor:
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316",
//                             }}
//                             onMouseEnter={(e) => {
//                               e.target.style.backgroundColor =
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "#9a3412"
//                                   : "#ea580c";
//                             }}
//                             onMouseLeave={(e) => {
//                               e.target.style.backgroundColor =
//                                 viewingCert && viewingCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316";
//                             }}
//                             onClick={() => handleView(cert)}
//                           >
//                             {viewingCert && viewingCert.certId === cert.certId
//                               ? "Hide"
//                               : "View"}
//                           </button>
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "5px 8px",
//                               fontSize: "12px",
//                               backgroundColor:
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316",
//                             }}
//                             onMouseEnter={(e) => {
//                               e.target.style.backgroundColor =
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "#9a3412"
//                                   : "#ea580c";
//                             }}
//                             onMouseLeave={(e) => {
//                               e.target.style.backgroundColor =
//                                 detailsCert && detailsCert.certId === cert.certId
//                                   ? "#c2410c"
//                                   : "#f97316";
//                             }}
//                             onClick={() => handleViewDetails(cert)}
//                           >
//                             {detailsCert && detailsCert.certId === cert.certId
//                               ? "Hide"
//                               : "Details"}
//                           </button>
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "5px 8px",
//                               fontSize: "12px",
//                               backgroundColor: "#f97316",
//                             }}
//                             onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
//                             onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
//                             onClick={() => onEdit(cert)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             style={{
//                               ...actionBtnBaseStyle,
//                               padding: "5px 8px",
//                               fontSize: "12px",
//                               backgroundColor: "#dc2626",
//                               cursor: deletingId === cert.certId ? "not-allowed" : "pointer",
//                               opacity: deletingId === cert.certId ? 0.5 : 1,
//                             }}
//                             onMouseEnter={(e) => {
//                               if (deletingId !== cert.certId) {
//                                 e.target.style.backgroundColor = "#b91c1c";
//                               }
//                             }}
//                             onMouseLeave={(e) => {
//                               if (deletingId !== cert.certId) {
//                                 e.target.style.backgroundColor = "#dc2626";
//                               }
//                             }}
//                             onClick={() => handleDelete(cert.certId)}
//                             disabled={deletingId === cert.certId}
//                           >
//                             {deletingId === cert.certId ? "..." : "Delete"}
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CertificateList;














///pagination

///////..
import React, { useEffect, useRef, useState } from "react";

const StudentDetailsModal = ({ cert, onClose }) => {
  if (!cert) return null;
  const handleDownloadImage = async () => {
    try {
      const imageUrl = `/${cert.studentImage}`;
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${cert.studentName || "student"}_photo.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Failed to download image:", err);
      window.open(`/${cert.studentImage}`, "_blank");
    }
  };

  const rows = [
    ["Certificate No.", cert.certNo],
    ["Student Name", cert.studentName],
    ["Father's Name", cert.fatherName],
    ["Branch", cert.branch],
    ["Course / Training", cert.course],
    ["Training Centre", cert.centre],
    ["College", cert.college],
    ["Qualification", cert.qualification],
    ["Date of Birth", cert.dob],
    ["Email ID", cert.email],
    ["Mobile No.", cert.mobile],
    ["Contact Address", cert.address],
    ["Start Date", cert.startDate],
    ["End Date", cert.endDate],
    ["Awarded On", cert.awardedOn],
  ];

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "16px",
  };

  const modalStyle = {
    backgroundColor: "#ecfdf5",
    border: "1px solid #a7f3d0",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    overflow: "hidden",
    width: "100%",
    maxWidth: "640px",
    maxHeight: "85vh",
    display: "flex",
    flexDirection: "column",
  };

  const headerStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    borderBottom: "1px solid #a7f3d0",
    backgroundColor: "#d1fae5",
  };

  const titleStyle = {
    fontSize: "18px",
    fontWeight: 600,
    color: "#1f2937",
    wordBreak: "break-word",
    margin: 0,
  };

  const closeBtnStyle = {
    color: "#6b7280",
    fontSize: "14px",
    fontWeight: 500,
    backgroundColor: "rgba(255,255,255,0.6)",
    border: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    flexShrink: 0,
  };

  const bodyStyle = {
    position: "relative",
    padding: "20px 24px",
    overflowY: "auto",
  };

  const imgStyle = {
    position: "absolute",
    top: "20px",
    right: "24px",
    width: "120px",
    height: "120px",
    objectFit: "cover",
    maxWidth: "120px",
    maxHeight: "120px",
    zIndex: 10,
    borderRadius: "8px",
    border: "1px solid #a7f3d0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px 40px",
    paddingRight: cert.studentImage ? "140px" : undefined,
  };

  const rowStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px 4px",
    borderBottom: "1px solid #d1fae5",
    paddingBottom: "8px",
  };

  const labelStyle = {
    fontSize: "16px",
    fontWeight: 700,
    color: "#1f2937",
  };

  const valueStyle = {
    fontSize: "16px",
    color: "#1f2937",
    textAlign: "right",
    marginLeft: "auto",
    wordBreak: "break-word",
    maxWidth: "70%",
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <div style={headerStyle}>
          <h4 style={titleStyle}>Student Details — {cert.studentName}</h4>
          <button style={closeBtnStyle} onClick={onClose}>
            Close ✕
          </button>
        </div>

        <div style={bodyStyle}>
          {cert.studentImage && (
            <div
              style={{
                position: "absolute",
                top: "20px",
                right: "24px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "6px",
                zIndex: 10,
              }}
            >
              <img
                src={`/${cert.studentImage}`}
                alt={cert.studentName}
                style={{ ...imgStyle, position: "static" }}
              />
              <button
                onClick={handleDownloadImage}
                style={{
                  fontSize: "12px",
                  fontWeight: 500,
                  color: "#ffffff",
                  backgroundColor: "#10b981",
                  border: "none",
                  padding: "4px 10px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  width: "120px",
                }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = "#059669")}
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#10b981")}
              >
                ⬇ Download
              </button>
            </div>
          )}
          <div style={gridStyle}>
            {rows.map(([label, value]) => (
              <div key={label} style={rowStyle}>
                <span style={labelStyle}>{label}: </span>
                <span style={valueStyle}>{value || "—"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const CertificateViewPanel = ({ cert, onClose }) => {
  if (!cert) return null;

  const rows = [
    ["Certificate No.", cert.certNo],
    ["Student Name", cert.studentName],
    ["Father's Name", cert.fatherName],
    ["Branch", cert.branch],
    ["Course / Training", cert.course],
    ["Training Centre", cert.centre],
    ["College", cert.college],
    ["Qualification", cert.qualification],
    ["Start Date", cert.startDate],
    ["End Date", cert.endDate],
    ["Awarded On", cert.awardedOn],
  ];

  return (
    <div
      style={{
        marginBottom: "24px",
        backgroundColor: "#fff7ed",
        border: "1px solid #fed7aa",
        borderRadius: "12px",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
          borderBottom: "1px solid #fed7aa",
          backgroundColor: "#ffedd5",
        }}
      >
        <h4
          style={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#1f2937",
            wordBreak: "break-word",
            margin: 0,
          }}
        >
          Certificate — {cert.studentName}
        </h4>
        <button
          style={{
            color: "#6b7280",
            fontSize: "14px",
            fontWeight: 500,
            backgroundColor: "rgba(255,255,255,0.6)",
            border: "none",
            padding: "6px 12px",
            borderRadius: "6px",
            cursor: "pointer",
            flexShrink: 0,
          }}
          onClick={onClose}
        >
          Close ✕
        </button>
      </div>

      <div
        style={{
          padding: "24px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "640px",
            backgroundColor: "#ffffff",
            border: "4px double #fdba74",
            borderRadius: "8px",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontSize: "13px",
              textTransform: "uppercase",
              letterSpacing: "2px",
              color: "#6b7280",
              marginBottom: "8px",
            }}
          >
            Certificate of Completion
          </p>
          <p
            style={{
              fontSize: "22px",
              fontWeight: 700,
              color: "#1f2937",
              marginBottom: "4px",
            }}
          >
            {cert.studentName || "—"}
          </p>
          <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "24px" }}>
            Cert No. {cert.certNo || "—"}
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "12px 32px",
              textAlign: "left",
              marginTop: "16px",
            }}
          >
            {rows.map(([label, value]) => (
              <div
                key={label}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #f3f4f6",
                  paddingBottom: "8px",
                }}
              >
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#6b7280",
                  }}
                >
                  {label}
                </span>
                <span
                  style={{
                    fontSize: "13px",
                    color: "#1f2937",
                    textAlign: "right",
                    marginLeft: "16px",
                    wordBreak: "break-word",
                  }}
                >
                  {value || "—"}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        style={{
          padding: "0 24px 20px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <button
          style={{
            backgroundColor: "#f97316",
            color: "#ffffff",
            fontWeight: 500,
            padding: "8px 20px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
          onClick={onClose}
        >
          ← Back to list
        </button>
      </div>
    </div>
  );
};

const CertificateList = ({ onSelect, onEdit }) => {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [deletingId, setDeletingId] = useState(null);
  const [detailsCert, setDetailsCert] = useState(null);
  const [viewingCert, setViewingCert] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10; // change this number as needed
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false,
  );
  const containerRef = useRef(null);

  useEffect(() => {
    const evaluate = () => {
      const windowWidth = typeof window !== "undefined" ? window.innerWidth : Infinity;
      const containerWidth = containerRef.current
        ? containerRef.current.getBoundingClientRect().width
        : Infinity;
      setIsMobile(windowWidth < 768 || containerWidth < 700);
    };

    evaluate();

    window.addEventListener("resize", evaluate);

    let observer;
    if (typeof ResizeObserver !== "undefined" && containerRef.current) {
      observer = new ResizeObserver(evaluate);
      observer.observe(containerRef.current);
    }

    return () => {
      window.removeEventListener("resize", evaluate);
      if (observer) observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch("/api/certificates");
        if (!res.ok) throw new Error("Failed to load certificates");
        const data = await res.json();
        setCertificates(data);
      } catch (err) {
        setError(err.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleDelete = async (certId) => {
    if (!window.confirm("Delete this certificate? This cannot be undone."))
      return;
    setDeletingId(certId);
    try {
      const res = await fetch(
        `/api/certificates/${certId}`,
        { method: "DELETE" },
      );
      if (!res.ok) throw new Error("Failed to delete certificate");
      setCertificates((prev) => prev.filter((c) => c.certId !== certId));
      if (detailsCert && detailsCert.certId === certId) setDetailsCert(null);
      if (viewingCert && viewingCert.certId === certId) setViewingCert(null);
    } catch (err) {
      setError(err.message || "Failed to delete certificate.");
    } finally {
      setDeletingId(null);
    }
  };

  const handleViewDetails = (cert) => {
    setDetailsCert((prev) =>
      prev && prev.certId === cert.certId ? null : cert,
    );
  };

  const handleView = (cert) => {
    setViewingCert((prev) =>
      prev && prev.certId === cert.certId ? null : cert,
    );
    if (typeof onSelect === "function") onSelect(cert);
  };
useEffect(() => {
  setCurrentPage(1);
}, [searchTerm]);
  const filteredCertificates = certificates.filter((cert) => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return true;
    return Object.values(cert || {}).some((val) => {
      if (val === null || val === undefined) return false;
      if (typeof val === "string" || typeof val === "number") {
        return String(val).toLowerCase().includes(term);
      }
      return false;
    });
  });
  const totalPages = Math.ceil(filteredCertificates.length / itemsPerPage) || 1;
const paginatedCertificates = filteredCertificates.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage,
);

  if (loading)
    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        }}
      >
        <div style={{ padding: "16px" }}>Loading...</div>
      </div>
    );
  if (error)
    return (
      <div
        style={{
          backgroundColor: "#f8d7da",
          color: "#842029",
          border: "1px solid #f5c2c7",
          borderRadius: "6px",
          padding: "12px 16px",
        }}
      >
        {error}
      </div>
    );

  const actionBtnBaseStyle = {
    fontWeight: 500,
    borderRadius: "6px",
    transition: "all 0.2s",
    fontSize: "14px",
    color: "#ffffff",
    border: "none",
    cursor: "pointer",
  };

  return (
    <div
      ref={containerRef}
      style={{ width: "100%", maxWidth: "100%", padding: "12px 8px", boxSizing: "border-box" }}
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
          overflow: "hidden",
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
        }}
      >
        <div style={{ padding: "10px", width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "stretch" : "center",
              justifyContent: "space-between",
              gap: "10px",
              marginBottom: "12px",

              whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",

            }}
          >
            <h4
              style={{
                color: "#1f2937",
                fontSize: "18px",
                fontWeight: 600,
                margin: 0,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              All Certificates
            </h4>

            <div
              style={{
                position: "relative",
                width: isMobile ? "100%" : "320px",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingLeft: "12px",
                  color: "#9ca3af",
                  pointerEvents: "none",
                  width: "32px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ width: "16px", height: "16px", flexShrink: 0 }}
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </span>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by name, cert no, branch, course..."
                style={{
                  width: "100%",
                  paddingLeft: "36px",
                  paddingRight: "32px",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  fontSize: "14px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm("")}
                  aria-label="Clear search"
                  style={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    right: 0,
                    display: "flex",
                    alignItems: "center",
                    paddingRight: "12px",
                    color: "#9ca3af",
                    fontSize: "14px",
                    lineHeight: 1,
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              )}
            </div>
          </div>

          <CertificateViewPanel
            cert={viewingCert}
            onClose={() => setViewingCert(null)}
          />

          <StudentDetailsModal
            cert={detailsCert}
            onClose={() => setDetailsCert(null)}
          />

          {certificates.length === 0 ? (
            <p style={{ color: "#6b7280", textAlign: "center", padding: "32px 0" }}>
              No certificates generated yet.
            </p>
          ) : filteredCertificates.length === 0 ? (
            <p style={{ color: "#6b7280", textAlign: "center", padding: "32px 0" }}>
              No certificates match your search.
            </p>
          ) : isMobile ? (
            /* Mobile Card View */
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
{paginatedCertificates.map((cert) => (                <div
                  key={cert.certId}
                  style={{
                    backgroundColor: "#f9fafb",
                    borderRadius: "8px",
                    padding: "16px",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
                      Cert No. :
                    </span>
                    <span style={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
                      {cert.certNo}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
                      Student Name :
                    </span>
                    <span style={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
                      {cert.studentName}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
                      Branch :
                    </span>
                    <span style={{ fontSize: "14px", color: "#374151" }}>{cert.branch}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
                      Course :
                    </span>
                    <span style={{ fontSize: "14px", color: "#374151" }}>{cert.course}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "12px",
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: 700, color: "#374151" }}>
                      Awarded On :
                    </span>
                    <span style={{ fontSize: "14px", color: "#374151" }}>{cert.awardedOn}</span>
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "8px",
                    }}
                  >
                    <button
                      style={{
                        ...actionBtnBaseStyle,
                        width: "100%",
                        padding: "10px 12px",
                        backgroundColor:
                          viewingCert && viewingCert.certId === cert.certId
                            ? "#c2410c"
                            : "#ea580c",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor =
                          viewingCert && viewingCert.certId === cert.certId
                            ? "#9a3412"
                            : "#c2410c";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor =
                          viewingCert && viewingCert.certId === cert.certId
                            ? "#c2410c"
                            : "#ea580c";
                      }}
                      onClick={() => handleView(cert)}
                    >
                      {viewingCert && viewingCert.certId === cert.certId ? "Hide" : "View"}
                    </button>
                    <button
                      style={{
                        ...actionBtnBaseStyle,
                        width: "100%",
                        padding: "10px 12px",
                        backgroundColor:
                          detailsCert && detailsCert.certId === cert.certId
                            ? "#c2410c"
                            : "#ea580c",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor =
                          detailsCert && detailsCert.certId === cert.certId
                            ? "#9a3412"
                            : "#c2410c";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor =
                          detailsCert && detailsCert.certId === cert.certId
                            ? "#c2410c"
                            : "#ea580c";
                      }}
                      onClick={() => handleViewDetails(cert)}
                    >
                      {detailsCert && detailsCert.certId === cert.certId
                        ? "Hide Details"
                        : "View Details"}
                    </button>
                    <button
                      style={{
                        ...actionBtnBaseStyle,
                        width: "100%",
                        padding: "10px 12px",
                        backgroundColor: "#f97316",
                      }}
                      onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
                      onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
                      onClick={() => onEdit(cert)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        ...actionBtnBaseStyle,
                        width: "100%",
                        padding: "10px 12px",
                        backgroundColor: "#dc2626",
                        cursor: deletingId === cert.certId ? "not-allowed" : "pointer",
                        opacity: deletingId === cert.certId ? 0.5 : 1,
                      }}
                      onMouseEnter={(e) => {
                        if (deletingId !== cert.certId) {
                          e.target.style.backgroundColor = "#b91c1c";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (deletingId !== cert.certId) {
                          e.target.style.backgroundColor = "#dc2626";
                        }
                      }}
                      onClick={() => handleDelete(cert.certId)}
                      disabled={deletingId === cert.certId}
                    >
                      {deletingId === cert.certId ? "..." : "Delete"}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            /* Desktop Table View */
            <div style={{ width: "100%", maxWidth: "100%" }}>
              <table
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  tableLayout: "fixed",
                  borderCollapse: "collapse",
                }}
              >
                <colgroup>
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "18%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "14%" }} />
                  <col style={{ width: "12%" }} />
                  <col style={{ width: "32%" }} />
                </colgroup>
                <thead style={{ backgroundColor: "#f9fafb" }}>
                  <tr>
                    {["Cert No.", "Student Name", "Branch", "Course", "Awarded On"].map(
                      (h) => (
                        <th
                          key={h}
                          style={{
                            padding: "8px 6px",
                            textAlign: "left",
                            fontSize: "11px",
                            fontWeight: 600,
                            color: "#6b7280",
                            textTransform: "uppercase",
                            letterSpacing: "0.03em",
                            borderBottom: "1px solid #e5e7eb",
                            wordBreak: "break-word",
                          }}
                        >
                          {h}
                        </th>
                      ),
                    )}
                    <th
                      style={{
                        padding: "8px 6px",
                        textAlign: "center",
                        fontSize: "11px",
                        fontWeight: 600,
                        color: "#6b7280",
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
{paginatedCertificates.map((cert) => (                    <tr
                      key={cert.certId}
                      style={{ backgroundColor: "#ffffff", transition: "background-color 0.15s" }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9fafb")}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffffff")}
                    >
                      <td
                        style={{
                          padding: "10px 6px",
                          wordBreak: "break-word",
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#111827",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {cert.certNo}
                      </td>
                      <td
                        style={{
                          padding: "10px 6px",
                          wordBreak: "break-word",
                          fontSize: "13px",
                          color: "#374151",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {cert.studentName}
                      </td>
                      <td
                        style={{
                          padding: "10px 6px",
                          wordBreak: "break-word",
                          fontSize: "13px",
                          color: "#374151",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {cert.branch}
                      </td>
                      <td
                        style={{
                          padding: "10px 6px",
                          wordBreak: "break-word",
                          fontSize: "13px",
                          color: "#374151",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {cert.course}
                      </td>
                      <td
                        style={{
                          padding: "10px 6px",
                          wordBreak: "break-word",
                          fontSize: "13px",
                          color: "#374151",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {cert.awardedOn}
                      </td>
                      <td
                        style={{
                          padding: "10px 6px",
                          textAlign: "center",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            style={{
                              ...actionBtnBaseStyle,
                              padding: "5px 8px",
                              fontSize: "12px",
                              backgroundColor:
                                viewingCert && viewingCert.certId === cert.certId
                                  ? "#c2410c"
                                  : "#f97316",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor =
                                viewingCert && viewingCert.certId === cert.certId
                                  ? "#9a3412"
                                  : "#ea580c";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor =
                                viewingCert && viewingCert.certId === cert.certId
                                  ? "#c2410c"
                                  : "#f97316";
                            }}
                            onClick={() => handleView(cert)}
                          >
                            {viewingCert && viewingCert.certId === cert.certId
                              ? "Hide"
                              : "View"}
                          </button>
                          <button
                            style={{
                              ...actionBtnBaseStyle,
                              padding: "5px 8px",
                              fontSize: "12px",
                              backgroundColor:
                                detailsCert && detailsCert.certId === cert.certId
                                  ? "#c2410c"
                                  : "#f97316",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor =
                                detailsCert && detailsCert.certId === cert.certId
                                  ? "#9a3412"
                                  : "#ea580c";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor =
                                detailsCert && detailsCert.certId === cert.certId
                                  ? "#c2410c"
                                  : "#f97316";
                            }}
                            onClick={() => handleViewDetails(cert)}
                          >
                            {detailsCert && detailsCert.certId === cert.certId
                              ? "Hide"
                              : "Details"}
                          </button>
                          <button
                            style={{
                              ...actionBtnBaseStyle,
                              padding: "5px 8px",
                              fontSize: "12px",
                              backgroundColor: "#f97316",
                            }}
                            onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
                            onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
                            onClick={() => onEdit(cert)}
                          >
                            Edit
                          </button>
                          <button
                            style={{
                              ...actionBtnBaseStyle,
                              padding: "5px 8px",
                              fontSize: "12px",
                              backgroundColor: "#dc2626",
                              cursor: deletingId === cert.certId ? "not-allowed" : "pointer",
                              opacity: deletingId === cert.certId ? 0.5 : 1,
                            }}
                            onMouseEnter={(e) => {
                              if (deletingId !== cert.certId) {
                                e.target.style.backgroundColor = "#b91c1c";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (deletingId !== cert.certId) {
                                e.target.style.backgroundColor = "#dc2626";
                              }
                            }}
                            onClick={() => handleDelete(cert.certId)}
                            disabled={deletingId === cert.certId}
                          >
                            {deletingId === cert.certId ? "..." : "Delete"}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {filteredCertificates.length > 0 && totalPages > 1 && (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      marginTop: "20px",
      flexWrap: "wrap",
    }}
  >
    <button
      onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
      disabled={currentPage === 1}
      style={{
        padding: "6px 12px",
        fontSize: "13px",
        borderRadius: "6px",
        border: "1px solid #d1d5db",
        backgroundColor: currentPage === 1 ? "#f3f4f6" : "#ffffff",
        cursor: currentPage === 1 ? "not-allowed" : "pointer",
        color: "#374151",
      }}
    >
      Prev
    </button>

    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <button
        key={page}
        onClick={() => setCurrentPage(page)}
        style={{
          padding: "6px 12px",
          fontSize: "13px",
          borderRadius: "6px",
          border: "1px solid #d1d5db",
          backgroundColor: page === currentPage ? "#f97316" : "#ffffff",
          color: page === currentPage ? "#ffffff" : "#374151",
          cursor: "pointer",
          fontWeight: page === currentPage ? 600 : 400,
        }}
      >
        {page}
      </button>
    ))}

    <button
      onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
      disabled={currentPage === totalPages}
      style={{
        padding: "6px 12px",
        fontSize: "13px",
        borderRadius: "6px",
        border: "1px solid #d1d5db",
        backgroundColor: currentPage === totalPages ? "#f3f4f6" : "#ffffff",
        cursor: currentPage === totalPages ? "not-allowed" : "pointer",
        color: "#374151",
      }}
    >
      Next
    </button>
  </div>
)}
        </div>
      </div>
    </div>
  );
};

export default CertificateList;